
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Sl9O", function(module, exports) {

$parcel$export(module.exports, "orderQuickOrder", () => $15db3efed97a4f04$export$1998c2c1ab115119);

var $03cFT = parcelRequire("03cFT");
parcelRequire("kcvY9");
parcelRequire("cxph1");
async function $15db3efed97a4f04$export$1998c2c1ab115119(order) {
    try {
        await (0, $03cFT.default).Cloud.run('orderQuickOrder', {
            'orderid': order.id
        });
        const currentUser = (0, $03cFT.default).User.current();
        await currentUser.fetch();
        const locationObject = order.get('locationobject');
        const deliveryInfo = order.get('orderObject').deliveryInfo;
        if (deliveryInfo != null) await $15db3efed97a4f04$var$setStorageDelivery(order, locationObject);
        else await $15db3efed97a4f04$var$setStoragePickUp(locationObject);
        return true;
    } catch (e) {
        alert(e.message);
        return false;
    }
}
async function $15db3efed97a4f04$var$setStoragePickUp(location) {
    const locationObject = {
        id: location.id,
        city: location.get('city'),
        address: location.get('address'),
        state: location.get('state'),
        zipcode: '' + location.get('zipcode'),
        phone: location.get('phonenumber')
    };
    const geoPoint = location.get('location');
    const pickupObject = {
        postalCode: '' + location.get('zipcode'),
        latitude: geoPoint.latitude,
        longitude: geoPoint.longitude
    };
    localStorage.setItem('location', JSON.stringify(locationObject));
    sessionStorage.setItem('pickupAddress', JSON.stringify(pickupObject));
    sessionStorage.setItem('deliveryBool', 'false');
    const currentUser = (0, $03cFT.default).User.current();
    if (currentUser != null) await currentUser.fetch();
    const restaurantGuid = location.get('guid');
    const toastLocation = await (0, $03cFT.default).Cloud.run('getToastLocation', {
        'restaurantGuid': restaurantGuid
    });
    localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));
    const toastOrderSchedule = await (0, $03cFT.default).Cloud.run('getToastOrderSchedule', {
        'restaurantGuid': restaurantGuid
    });
    localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));
}
async function $15db3efed97a4f04$var$setStorageDelivery(order, deliveryLocation) {
    const locationObject = {
        id: deliveryLocation.id,
        city: deliveryLocation.get('city'),
        address: deliveryLocation.get('address'),
        state: deliveryLocation.get('state'),
        zipcode: '' + deliveryLocation.get('zipcode'),
        phone: deliveryLocation.get('phonenumber')
    };
    const deliveryInfo = order.get('orderObject').deliveryInfo;
    var deliveryAddress = {
        'addressLabel': deliveryInfo.address1,
        'postalCode': deliveryInfo.zipCode,
        'city': deliveryInfo.city,
        'stateCode': deliveryInfo.state,
        'instructions': deliveryInfo.notes
    };
    const apt = deliveryInfo.address2;
    if (apt != null && apt != '') deliveryAddress.apt = apt;
    const addressid = order.get('addressid');
    if (addressid != null) deliveryAddress.id = addressid;
    localStorage.setItem('location', JSON.stringify(locationObject));
    sessionStorage.setItem('deliveryAddress', JSON.stringify(deliveryAddress));
    sessionStorage.setItem('deliveryBool', 'true');
    const currentUser = (0, $03cFT.default).User.current();
    if (currentUser != null) await currentUser.fetch();
    const restaurantGuid = deliveryLocation.get('guid');
    const toastLocation = await (0, $03cFT.default).Cloud.run('getToastLocation', {
        'restaurantGuid': restaurantGuid
    });
    localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));
    const toastOrderSchedule = await (0, $03cFT.default).Cloud.run('getToastOrderSchedule', {
        'restaurantGuid': restaurantGuid
    });
    localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));
//goToNextPage('/checkout');
}

});

parcelRegister("jPxhr", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", () => $e6fc98820934cce0$export$842dcfa371c6bb83);
$parcel$export(module.exports, "formatPhone", () => $e6fc98820934cce0$export$10c09b2cff9813eb);
function $e6fc98820934cce0$export$842dcfa371c6bb83(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
function $e6fc98820934cce0$export$10c09b2cff9813eb(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return null;
}

});


var $03cFT = parcelRequire("03cFT");

var $kcvY9 = parcelRequire("kcvY9");

var $cxph1 = parcelRequire("cxph1");

var $1Sl9O = parcelRequire("1Sl9O");

var $3w2h1 = parcelRequire("3w2h1");
var $218711fccd48f794$exports = {};
(function() {
    var aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Array.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            var d = this;
            d instanceof String && (d = String(d));
            var e = d.length;
            c = c || 0;
            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                var f = d[c];
                if (f === b || Object.is(f, b)) return !0;
            }
            return !1;
        };
    });
    function ea(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function fa(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function ha(a, b, c) {
        ha = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ea : fa;
        return ha.apply(null, arguments);
    }
    function h(a) {
        const b = [];
        ia(new ja, a, b);
        return b.join("");
    }
    function ja() {}
    function ia(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (Array.isArray(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    var e = "";
                    for(var f = 0; f < b; f++)c.push(e), ia(a, d[f], c), e = ",";
                    c.push("]");
                    return;
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ka(d, c), c.push(":"), ia(a, f, c), e = ","));
                    c.push("}");
                    return;
                }
            }
            switch(typeof b){
                case "string":
                    ka(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var la = {
        '"': '\\"',
        "\\": "\\\\",
        "/": "\\/",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\v": "\\u000b"
    }, ma = /\uffff/.test("\uffff") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
    function ka(a, b) {
        b.push('"', a.replace(ma, function(c) {
            let d = la[c];
            d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).slice(1), la[c] = d);
            return d;
        }), '"');
    }
    var t = "https://api2.branch.io";
    function v(a) {
        a = String(a);
        try {
            return JSON.parse(a);
        } catch (b) {}
        throw Error("Invalid JSON string: " + a);
    }
    function w(a) {
        try {
            return "object" === typeof JSON && "function" === typeof JSON.stringify ? JSON.stringify(a) : h(a);
        } catch (b) {}
        throw Error("Could not stringify object");
    }
    var na = !1, oa = 2, pa = 200, qa = 5E3, ra = "", sa = 6048E5, x = {}, y = null, ta = "undefined" !== typeof window && !!(window.performance && window.performance.timing && window.performance.timing.navigationStart), ua = "", va = {
        "/v1/open": "",
        "/v1/pageview": "",
        "/v2/event/standard": "user_data",
        "/v2/event/custom": "user_data"
    };
    function wa(a) {
        return a && "number" === typeof a ? (Date.now() - a).toString() : null;
    }
    var xa = {
        didClickJourneyClose: "Button(X)",
        didClickJourneyContinue: "Dismiss Journey text",
        didClickJourneyBackgroundDismiss: "Background Dismiss",
        didScrollJourneyBackgroundDismiss: "Background Dismiss"
    }, z = !1, ya = !1, za = {
        "/v1/open": {
            link_identifier: "\\d+"
        },
        "/v1/pageview": {
            event: "pageview"
        },
        "/v1/dismiss": {
            event: "dismiss"
        },
        "/v1/url": {}
    }, Aa = !1;
    function Ba(a, b) {
        var c = document.createElement("a");
        c.href = a;
        a = [
            t,
            "https://app.link",
            "https://bnc.lt"
        ];
        var d = c.origin;
        d.endsWith("/") && (d = d.substring(0, d.length - 1));
        if (!a.includes(d)) return !1;
        c = c.pathname;
        "/" != c[0] && (c = "/" + c);
        c = za[c];
        if (!c) return !0;
        if (0 < Object.keys(c).length) {
            if (!b) return !0;
            for(var e in c)if (a = new RegExp(c[e]), !b.hasOwnProperty(e) || !a.test(b[e])) return !0;
        }
        return !1;
    }
    function Ca(a, b) {
        if (a || b) {
            a = "https://bnc.lt/a/" + a + "?";
            for(var c = "tags alias channel feature stage campaign type duration sdk source data".split(" "), d = 0; d < c.length; d++){
                var e = c[d], f = b[e];
                if (f) {
                    if ("tags" === e && Array.isArray(f)) for(var m = 0; m < f.length; m++)a = ("?" === a[a.length - 1] ? a + e : a + "&" + e) + "=" + encodeURIComponent(f[m]);
                    else if ("string" === typeof f && 0 < f.length || "number" === typeof f) "data" === e && "string" === typeof f && (f = Da(f)), a = ("?" === a[a.length - 1] ? a + e : a + "&" + e) + "=" + encodeURIComponent(f);
                }
            }
            return a;
        }
    }
    function Ea(a) {
        a && (a.Fa = null, a.ga = null, a.J = null, a.v = null, a.m = null, a.L = null, a.F && delete a.F, a.G && delete a.G, a.g.remove("branch_view_enabled"), Fa(a.g, {}, !0));
    }
    function A(a, b, c) {
        a = a.replace(/\$(\d)/g, function(d, e) {
            return b[parseInt(e, 10) - 1];
        });
        c && (a += "\n Failure Code:" + c);
        na && console && console.log(a);
        return a;
    }
    function Ga(a) {
        var b = a.has_app;
        return {
            data: a.data || "",
            data_parsed: a.data_parsed || {},
            has_app: void 0 === b ? null : b,
            identity: a.identity || null,
            developer_identity: a.identity || null,
            referring_identity: a.referring_identity || null,
            referring_link: a.referring_link || null
        };
    }
    function Ha(a) {
        var b = /^\$journeys_\S+$/, c = a.data, d = {};
        if (!c) return {};
        switch(typeof c){
            case "string":
                try {
                    c = v(c);
                } catch (e) {
                    c = {};
                }
                break;
            case "object":
                break;
            default:
                c = {};
        }
        Object.keys(c).forEach(function(e) {
            b.test(e) && (d[e] = c[e]);
        });
        return d;
    }
    function Ia() {
        return B() ? document.referrer : String(window.location);
    }
    function Ja(a) {
        a.source = "web-sdk";
        var b = a.data;
        switch(typeof b){
            case "string":
                try {
                    b = v(b);
                } catch (d) {
                    b = {
                        _bncNoEval: !0
                    };
                }
                break;
            case "object":
                break;
            default:
                b = {};
        }
        var c = b.$og_redirect || b.$fallback_url || b.$desktop_url;
        b.$canonical_url || (b.$canonical_url = Ia());
        b.$og_title || (b.$og_title = c ? null : C("title"));
        b.$og_description || (b.$og_description = c ? null : C("description"));
        b.$og_image_url || (b.$og_image_url = c ? null : C("image"));
        b.$og_video || (b.$og_video = c ? null : C("video"));
        b.$og_type || (b.$og_type = c ? null : C("type"));
        "string" === typeof b.$desktop_url && (b.$desktop_url = b.$desktop_url.replace(/#r:[a-z0-9-_]+$/i, "").replace(/([\?&]_branch_match_id=\d+)/, ""));
        try {
            v(b);
        } catch (d) {
            b = h(b);
        }
        a.data = b;
        return a;
    }
    function Ka(a) {
        function b(d) {
            return "" !== d;
        }
        if (!a || "string" !== typeof a) return "";
        var c = document.createElement("a");
        c.href = a;
        a = c.pathname && c.pathname.split("/").filter(b);
        return Array.isArray(a) && a.length ? a[a.length - 1] + c.search : c.search;
    }
    function D(a, b, c) {
        a && "object" === typeof a || (a = {});
        if (!b || "object" !== typeof b) return a;
        for(var d in b)if (b.hasOwnProperty(d)) {
            var e = b[d];
            !c || void 0 !== e && null !== e ? a[d] = e : delete a[d];
        }
        return a;
    }
    function La() {
        try {
            var a = (B() && Ma() ? window.top.location.hash : window.location.hash).match(RegExp("r:([^&]*)"));
            if (a && 1 <= a.length) return a[1];
        } catch (b) {}
    }
    function Na(a) {
        return !!/^((?!chrome|android|crios|firefox|fxios|edg|yabrowser).)*safari/i.test(a);
    }
    function Oa(a, b) {
        if ((a = /version\/([^ ]*)/i.exec(a)) && a[1]) try {
            if (parseFloat(a[1]) >= (b || 11)) return !0;
        } catch (c) {}
        return !1;
    }
    function F() {
        var a = navigator.userAgent;
        return a.match(/android/i) ? "android" : a.match(/ipad/i) || a && Na(a) && a && -1 < a.indexOf("Macintosh") && Oa(a, 13) && screen.height > screen.width ? "ipad" : a.match(/i(os|p(hone|od))/i) ? "ios" : a.match(/\(BB[1-9][0-9]*;/i) ? "blackberry" : a.match(/Windows Phone/i) ? "windows_phone" : a.match(/Kindle/i) || a.match(/Silk/i) || a.match(/KFTT/i) || a.match(/KFOT/i) || a.match(/KFJWA/i) || a.match(/KFJWI/i) || a.match(/KFSOWI/i) || a.match(/KFTHWA/i) || a.match(/KFTHWI/i) || a.match(/KFAPWA/i) || a.match(/KFAPWI/i) ? "kindle" : a.match(/(Windows|Macintosh|Linux)/i) ? "desktop" : "other";
    }
    function Pa() {
        var a = navigator.userAgent;
        return Na(a) ? Oa(a, 11) : !1;
    }
    function Qa() {
        var a = navigator.userAgent;
        return !!window.webkitURL && a && a && /(iPad|iPod|iPhone)/.test(a) && !/(chrome|crios)/i.test(a) && !/(fxios|firefox)/i.test(a) && !/edg/i.test(a) && !/(opt|opr)/i.test(a) && !/yabrowser/i.test(a);
    }
    function Ra(a) {
        try {
            var b = (B() && Ma() ? window.top.location.search : window.location.search).substring(1).match(new RegExp(a + "=([^&]*)"));
            if (b && 1 <= b.length) return b[1];
        } catch (c) {}
    }
    function Sa(a) {
        return a.replace(/(\-\w)/g, function(b) {
            return b[1].toUpperCase();
        });
    }
    function Da(a) {
        var b = "", c, d = 0;
        a = a.replace(/\r\n/g, "\n");
        var e = "";
        for(c = 0; c < a.length; c++){
            var f = a.charCodeAt(c);
            128 > f ? e += String.fromCharCode(f) : (127 < f && 2048 > f ? e += String.fromCharCode(f >> 6 | 192) : (e += String.fromCharCode(f >> 12 | 224), e += String.fromCharCode(f >> 6 & 63 | 128)), e += String.fromCharCode(f & 63 | 128));
        }
        for(a = e; d < a.length;){
            var m = a.charCodeAt(d++);
            e = a.charCodeAt(d++);
            c = a.charCodeAt(d++);
            f = m >> 2;
            m = (m & 3) << 4 | e >> 4;
            var k = (e & 15) << 2 | c >> 6;
            var g = c & 63;
            isNaN(e) ? g = k = 64 : isNaN(c) && (g = 64);
            b = b + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(f) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(m) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(k) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(g);
        }
        return b;
    }
    function Ta(a) {
        return Ua(a) ? atob(a) : a;
    }
    function Ua(a) {
        if ("string" !== typeof a || "" === a || "" === a.trim()) return !1;
        try {
            return btoa(atob(a)) === a;
        } catch (b) {
            return !1;
        }
    }
    function Va(a) {
        a && a.browser_fingerprint_id && !Ua(a.browser_fingerprint_id) && (a.browser_fingerprint_id = btoa(a.browser_fingerprint_id));
        a && a.alternative_browser_fingerprint_id && !Ua(a.alternative_browser_fingerprint_id) && (a.alternative_browser_fingerprint_id = btoa(a.alternative_browser_fingerprint_id));
        return a;
    }
    function Wa(a) {
        a && Ua(a.browser_fingerprint_id) && (a.browser_fingerprint_id = atob(a.browser_fingerprint_id));
        a && Ua(a.alternative_browser_fingerprint_id) && (a.alternative_browser_fingerprint_id = atob(a.alternative_browser_fingerprint_id));
        return a;
    }
    function Xa(a, b, c) {
        "function" === typeof a.addEventListener ? a.addEventListener(b, c, void 0) : "function" === typeof a.attachEvent ? a.attachEvent("on" + b, c) : a["on" + b] = c;
    }
    function Ya(a) {
        if (!a) return null;
        -1 < a.indexOf("://") ? a = a.split("://")[1] : "/" === a.charAt(0) && (a = a.slice(1));
        return a;
    }
    function C(a) {
        a = String(a);
        var b = b || null;
        (a = document.querySelector('meta[property="og:' + a + '"]')) && a.content && (b = a.content);
        return b;
    }
    function Za() {
        var a = document.getElementsByTagName("meta"), b = {};
        if (!a || 0 === a.length) return b;
        for(var c = {
            hostedIOS: null,
            hostedAndroid: null,
            applinksIOS: null,
            applinksAndroid: null,
            twitterIOS: null,
            twitterAndroid: null
        }, d = 0; d < a.length; d++)if ((a[d].getAttribute("name") || a[d].getAttribute("property")) && a[d].getAttribute("content")) {
            var e = a[d].getAttribute("name"), f = a[d].getAttribute("property");
            e = e || f;
            f = e.split(":");
            3 === f.length && "branch" === f[0] && "deeplink" === f[1] && ("$ios_deeplink_path" === f[2] ? c.hostedIOS = Ya(a[d].getAttribute("content")) : "$android_deeplink_path" === f[2] ? c.hostedAndroid = Ya(a[d].getAttribute("content")) : b[f[2]] = a[d].getAttribute("content"));
            "al:ios:url" === e && (c.applinksIOS = Ya(a[d].getAttribute("content")));
            "twitter:app:url:iphone" === e && (c.twitterIOS = Ya(a[d].getAttribute("content")));
            "al:android:url" === e && (c.applinksAndroid = Ya(a[d].getAttribute("content")));
            "twitter:app:url:googleplay" === e && (c.twitterAndroid = Ya(a[d].getAttribute("content")));
        }
        c && "object" === typeof c && 0 !== Object.keys(c || {}).length && (c.hostedIOS ? b.$ios_deeplink_path = c.hostedIOS : c.applinksIOS ? b.$ios_deeplink_path = c.applinksIOS : c.twitterIOS && (b.$ios_deeplink_path = c.twitterIOS), c.hostedAndroid ? b.$android_deeplink_path = c.hostedAndroid : c.applinksAndroid ? b.$android_deeplink_path = c.applinksAndroid : c.twitterAndroid && (b.$android_deeplink_path = c.twitterAndroid), b.hasOwnProperty("$ios_deeplink_path") && b.hasOwnProperty("$android_deeplink_path") && b.$ios_deeplink_path === b.$android_deeplink_path && (b.$deeplink_path = b.$ios_deeplink_path));
        return b;
    }
    function $a() {
        try {
            if (navigator.languages && 0 < navigator.languages.length) var a = navigator.languages[0];
            else navigator.language && (a = navigator.language);
            a = a.substring(0, 2).toUpperCase();
        } catch (b) {
            a = null;
        }
        return a;
    }
    function ab(a, b) {
        var c = [];
        b.forEach(function(d) {
            -1 === a.indexOf(d) && c.push(d);
        });
        return c;
    }
    var bb = [
        "purchase"
    ], cb = {
        missingPurchaseEvent: "event name is either missing, of the wrong type or not valid. Please specify 'purchase' as the event name.",
        missingCommerceData: "commerce_data is either missing, of the wrong type or empty. Please ensure that commerce_data is constructed correctly.",
        invalidKeysForRoot: "Please remove the following keys from the root of commerce_data: ",
        invalidKeysForProducts: "Please remove the following keys from commerce_data.products: ",
        invalidProductListType: "commerce_data.products must be an array of objects",
        invalidProductType: "Each product in the products list must be an object"
    };
    function db(a) {
        var b = "sku name price quantity brand category variant".split(" "), c = ab("common type transaction_id currency revenue revenue_in_usd exchange_rate shipping tax coupon affiliation persona products".split(" "), Object.keys(a));
        if (c.length) return cb.invalidKeysForRoot + c.join(", ");
        var d = [], e;
        if (a.hasOwnProperty("products")) {
            if (!Array.isArray(a.products)) return cb.invalidProductListType;
            a.products.forEach(function(f) {
                "object" !== typeof f && (e = cb.invalidProductType);
                d = d.concat(ab(b, Object.keys(f)));
            });
            if (e) return e;
            if (d.length) return cb.invalidKeysForProducts + d.join(", ");
        }
        return null;
    }
    function eb(a, b) {
        return a && "string" === typeof a && -1 !== bb.indexOf(a.toLowerCase()) ? b && "object" === typeof b && 0 !== Object.keys(b || {}).length ? (a = db(b)) ? a : null : cb.missingCommerceData : cb.missingPurchaseEvent;
    }
    function fb(a) {
        return "string" !== typeof a ? null : a.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function H(a, b, c) {
        if (null !== c && void 0 !== c) {
            if ("object" === typeof c && 0 === Object.keys(c || {}).length) return a;
            a[b] = c;
        }
        return a;
    }
    function gb() {
        var a = {};
        var b = {};
        b = H(b, "$og_title", C("title"));
        b = H(b, "$og_description", C("description"));
        b = H(b, "$og_image_url", C("image"));
        b = H(b, "$og_video", C("video"));
        b = (b = H(b, "$og_type", C("type"))) && 0 < Object.keys(b).length ? b : null;
        a = H(a, "og_data", b);
        a = H(a, "hosted_deeplink_data", Za());
        b = document.getElementsByTagName("title");
        a = H(a, "title", 0 < b.length ? b[0].innerText : null);
        b = document.querySelector('meta[name="description"]');
        a = H(a, "description", b && b.content ? b.content : null);
        b = document.querySelector('link[rel="canonical"]');
        return (a = H(a, "canonical_url", b && b.href ? b.href : null)) && 0 < Object.keys(a).length ? a : {};
    }
    var hb = "ADD_TO_CART ADD_TO_WISHLIST VIEW_CART INITIATE_PURCHASE ADD_PAYMENT_INFO PURCHASE SPEND_CREDITS SEARCH VIEW_ITEM VIEW_ITEMS RATE SHARE COMPLETE_REGISTRATION COMPLETE_TUTORIAL ACHIEVE_LEVEL UNLOCK_ACHIEVEMENT LOGIN SUBSCRIBE START_TRIAL INVITE RESERVE VIEW_AD CLICK_AD INITIATE_STREAM COMPLETE_STREAM".split(" "), ib = "transaction_id revenue currency shipping tax coupon affiliation search_query description".split(" ");
    function jb(a) {
        if (!a || 0 === Object.keys(a).length) return null;
        for(var b = ab(ib, Object.keys(a)), c = {}, d = 0; d < b.length; d++){
            var e = b[d];
            c[e] = a[e];
            delete a[e];
        }
        return {
            custom_data: kb(c),
            event_data: a
        };
    }
    function I(a, b) {
        return !b || null === a && "object" === b ? !1 : "array" === b ? Array.isArray(a) : typeof a === b && !Array.isArray(a);
    }
    function lb(a) {
        var b = {};
        b = H(b, "http_origin", document.URL);
        b = H(b, "user_agent", navigator.userAgent);
        b = H(b, "language", $a());
        b = H(b, "screen_width", screen.width || 0);
        b = H(b, "screen_height", screen.height || 0);
        b = H(b, "http_referrer", document.referrer);
        b = H(b, "browser_fingerprint_id", a.L);
        b = H(b, "developer_identity", a.m);
        b = H(b, "identity", a.m);
        b = H(b, "sdk", "web");
        b = H(b, "sdk_version", "2.87.1");
        b = mb(b, "model", y ? y.model : "");
        return b = mb(b, "os_version", y ? y.platformVersion : "");
    }
    function B() {
        return window.self !== window.top;
    }
    function Ma() {
        var a = "true";
        try {
            window.top.location.search && (a = "true");
        } catch (b) {
            return !1;
        }
        return "true" === a;
    }
    function nb(a) {
        return a ? a : B() ? Ma() ? window.top.document.referrer : "" : document.referrer;
    }
    function kb(a) {
        if (!I(a, "object") || 0 === Object.keys(a).length) return {};
        for(var b in a)if (a.hasOwnProperty(b)) {
            var c = b;
            var d = a[b];
            d = I(d, "object") || I(d, "array") ? w(d) : null === d ? "null" : d.toString();
            a[c] = d;
        }
        return a;
    }
    function ob(a, b) {
        a = a ? D({}, a) : {};
        return b && 0 < Object.keys(b).length ? 0 < Object.keys(a).length ? D(a, b) : D({}, b) : a;
    }
    function J(a) {
        "" !== ra && a.setAttribute("nonce", ra);
    }
    function pb(a, b) {
        isNaN(b) || 0 >= b ? a() : setTimeout(a, b);
    }
    function qb() {
        navigator.userAgentData ? navigator.userAgentData.getHighEntropyValues([
            "model",
            "platformVersion"
        ]).then(function(a) {
            var b = a.model;
            if (a = a.platformVersion) {
                var c = /^([1-9]\d*)\.(0\d*)(\.[0]\d*){1,}$/;
                -1 !== a.indexOf(".") && (a = a.replace(c, a.substring(0, a.indexOf("."))));
            }
            y = {
                model: b,
                platformVersion: a
            };
        }) : y = null;
    }
    function mb(a, b, c) {
        "string" === typeof c && c && (a[b] = c);
        return a;
    }
    function rb(a, b = {}, c) {
        const d = [
            "/v2/event/standard",
            "/v2/event/custom"
        ], e = {};
        e.dma_eea = b.eeaRegion;
        e.dma_ad_personalization = b.adPersonalizationConsent;
        e.dma_ad_user_data = b.adUserDataUsageConsent;
        if ([
            "/v1/open",
            "/v1/pageview"
        ].includes(c)) Object.assign(a, e);
        else if (d.includes(c)) try {
            let f;
            a.user_data ? f = JSON.parse(a.user_data) : f = {};
            Object.assign(f, e);
            a.user_data = JSON.stringify(f);
        } catch (f) {
            console.error(`setDMAParams:: ${a.user_data} is not a valid JSON string`);
        }
    }
    var sb = {};
    function K(a, b) {
        return function(c, d, e) {
            if (z) return !1;
            if ("number" === typeof e || e) {
                if (0 === b) {
                    if ("object" !== typeof e) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "an object"
                    ]);
                } else if (3 === b) {
                    if (!(e instanceof Array)) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "an array"
                    ]);
                } else if (2 === b) {
                    if ("number" !== typeof e) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "a number"
                    ]);
                } else if (4 === b) {
                    if ("boolean" !== typeof e) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "a boolean"
                    ]);
                } else {
                    if ("string" !== typeof e) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "a string"
                    ]);
                    if (1 !== b && !b.test(e)) return A("API request $1, parameter $2 is not $3", [
                        c,
                        d,
                        "in the proper format"
                    ]);
                }
            } else if (a) return A("API request $1 missing parameter $2", [
                c,
                d
            ]);
            return !1;
        };
    }
    function tb(a) {
        return D(a, {
            browser_fingerprint_id: K(!0, 1),
            identity_id: K(!0, 1),
            sdk: K(!0, 1),
            session_id: K(!0, 1)
        });
    }
    var ub = {
        destination: t,
        endpoint: "/v1/open",
        method: "POST",
        h: {
            browser_fingerprint_id: K(!1, 1),
            alternative_browser_fingerprint_id: K(!1, 1),
            identity_id: K(!1, 1),
            identity: K(!1, 1),
            link_identifier: K(!1, 1),
            sdk: K(!1, 1),
            options: K(!1, 0),
            initial_referrer: K(!1, 1),
            tracking_disabled: K(!1, 4),
            current_url: K(!1, 1),
            screen_height: K(!1, 2),
            screen_width: K(!1, 2),
            model: K(!1, 1),
            os_version: K(!1, 1)
        }
    }, vb = {
        destination: "https://app.link",
        endpoint: "/_r",
        method: "GET",
        S: !0,
        h: {
            sdk: K(!0, 1),
            _t: K(!1, 1),
            branch_key: K(!0, 1)
        }
    }, wb = {
        destination: t,
        endpoint: "/v1/url",
        method: "POST",
        sa: "obj",
        h: tb({
            alias: K(!1, 1),
            campaign: K(!1, 1),
            channel: K(!1, 1),
            data: K(!1, 1),
            feature: K(!1, 1),
            identity_id: K(!0, 1),
            stage: K(!1, 1),
            tags: K(!1, 3),
            type: K(!1, 2),
            source: K(!1, 1),
            instrumentation: K(!1, 1)
        })
    }, xb = {
        destination: t,
        endpoint: "/v1/qr-code",
        method: "POST",
        sa: "obj",
        h: tb({
            alias: K(!1, 1),
            campaign: K(!1, 1),
            channel: K(!1, 1),
            data: K(!1, 1),
            qr_code_settings: K(!1, 1),
            feature: K(!1, 1),
            identity_id: K(!0, 1),
            stage: K(!1, 1),
            tags: K(!1, 3),
            type: K(!1, 2),
            source: K(!1, 1)
        })
    }, yb = {
        destination: t,
        endpoint: "/v1/deepview",
        S: !0,
        method: "POST",
        h: tb({
            campaign: K(!1, 1),
            _t: K(!1, 1),
            channel: K(!1, 1),
            data: K(!0, 1),
            feature: K(!1, 1),
            link_click_id: K(!1, 1),
            open_app: K(!1, 4),
            append_deeplink_path: K(!1, 4),
            stage: K(!1, 1),
            tags: K(!1, 3),
            deepview_type: K(!0, 1),
            source: K(!0, 1)
        })
    }, zb = {
        destination: t,
        endpoint: "/v2/event/standard",
        method: "POST",
        h: {
            name: K(!0, 1),
            user_data: K(!0, 1),
            custom_data: K(!1, 1),
            event_data: K(!1, 1),
            content_items: K(!1, 1),
            customer_event_alias: K(!1, 1)
        }
    }, Ab = {
        destination: t,
        endpoint: "/v2/event/custom",
        method: "POST",
        h: {
            name: K(!0, 1),
            user_data: K(!0, 1),
            custom_data: K(!1, 1),
            event_data: K(!1, 1),
            content_items: K(!1, 1),
            customer_event_alias: K(!1, 1)
        }
    }, Bb = {
        destination: t,
        endpoint: "/v1/pageview",
        method: "POST",
        h: tb({
            event: K(!0, 1),
            metadata: K(!1, 0),
            initial_referrer: K(!1, 1),
            tracking_disabled: K(!1, 4),
            branch_view_id: K(!1, 1),
            no_journeys: K(!1, 4),
            user_language: K(!1, 1),
            open_app: K(!1, 4),
            has_app_websdk: K(!1, 4),
            source: K(!1, 1),
            feature: K(!1, 1),
            is_iframe: K(!1, 4),
            data: K(!1, 0),
            callback_string: K(!1, 1),
            audience_rule_id: K(!1, 1),
            journey_dismissals: K(!1, 0),
            identity_id: K(!1, 1),
            identity: K(!0, 1),
            session_referring_link_data: K(!1, 1),
            session_link_click_id: K(!1, 1)
        })
    }, Cb = {
        destination: t,
        endpoint: "/v1/dismiss",
        method: "POST",
        h: tb({
            event: K(!0, 1),
            metadata: K(!1, 0),
            initial_referrer: K(!1, 1),
            tracking_disabled: K(!1, 4),
            branch_view_id: K(!1, 1),
            no_journeys: K(!1, 4),
            user_language: K(!1, 1),
            open_app: K(!1, 4),
            has_app_websdk: K(!1, 4),
            source: K(!1, 1),
            feature: K(!1, 1),
            is_iframe: K(!1, 4),
            data: K(!1, 0),
            callback_string: K(!1, 1),
            audience_rule_id: K(!1, 1),
            journey_dismissals: K(!1, 0),
            dismissal_source: K(!1, 1)
        })
    }, Db = {
        destination: t,
        endpoint: "/v1/cpid",
        method: "POST",
        h: {
            user_data: K(!0, 1)
        }
    }, Eb = {
        destination: t,
        endpoint: "/v1/cpid/latd",
        method: "POST",
        h: {
            user_data: K(!0, 1)
        }
    };
    function Fb() {
        for(var a = [
            "session",
            "cookie",
            "pojo"
        ], b = 0; b < a.length; b++){
            var c = this[a[b]];
            c = "function" === typeof c ? c() : c;
            if (c.isEnabled()) return c.H = {}, c;
        }
    }
    function L(a) {
        return "branch_session" === a || "branch_session_first" === a ? a : "BRANCH_WEBSDK_KEY" + a;
    }
    function Gb(a) {
        return "true" === a ? !0 : "false" === a ? !1 : a;
    }
    function Hb(a) {
        return "branch_session" === a || "branch_session_first" === a || 0 === a.indexOf("BRANCH_WEBSDK_KEY");
    }
    function Ib(a) {
        a = a.trim();
        var b = a.indexOf("=");
        return {
            name: a.substring(0, b),
            value: Gb(a.substring(b + 1, a.length))
        };
    }
    function Jb(a) {
        try {
            var b = a && localStorage ? localStorage : sessionStorage;
        } catch (c) {
            return {
                isEnabled: function() {
                    return !1;
                }
            };
        }
        return {
            getAll: function() {
                if ("undefined" === typeof b) return null;
                var c = null, d;
                for(d in b)0 === d.indexOf("BRANCH_WEBSDK_KEY") && (null === c && (c = {}), c[d.replace("BRANCH_WEBSDK_KEY", "")] = Gb(b.getItem(d)));
                return Wa(c);
            },
            get: function(c, d) {
                return "browser_fingerprint_id" === c || "alternative_browser_fingerprint_id" === c ? d && localStorage ? Ta(localStorage.getItem(L(c))) : Ta(b.getItem(L(c))) : Gb(d && localStorage ? localStorage.getItem(L(c)) : b.getItem(L(c)));
            },
            set: function(c, d, e) {
                e && localStorage ? localStorage.setItem(L(c), d) : b.setItem(L(c), d);
            },
            remove: function(c, d) {
                d && localStorage ? localStorage.removeItem(L(c)) : b.removeItem(L(c));
            },
            clear: function() {
                Object.keys(b).forEach(function(c) {
                    0 === c.indexOf("BRANCH_WEBSDK_KEY") && b.removeItem(c);
                });
            },
            isEnabled: function() {
                try {
                    return b.setItem("test", ""), b.removeItem("test"), !0;
                } catch (c) {
                    return !1;
                }
            }
        };
    }
    Fb.prototype.local = function() {
        return Jb(!0);
    };
    Fb.prototype.session = function() {
        return Jb(!1);
    };
    function Kb() {
        function a(b, c) {
            c && (b = L(b));
            document.cookie = b + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
        }
        return {
            getAll: function() {
                for(var b = {}, c = document.cookie.split(";"), d = 0; d < c.length; d++){
                    var e = Ib(c[d]);
                    e && e.hasOwnProperty("name") && e.hasOwnProperty("value") && Hb(e.name) && (b[e.name.replace("BRANCH_WEBSDK_KEY", "")] = e.value);
                }
                return b;
            },
            get: function(b) {
                b = L(b);
                for(var c = document.cookie.split(";"), d = 0; d < c.length; d++){
                    var e = Ib(c[d]);
                    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("value") && e.name === b) return e.value;
                }
                return null;
            },
            set: function(b, c) {
                document.cookie = L(b) + "=" + c + "; path=/";
            },
            remove: function(b) {
                a(b, !0);
            },
            clear: function() {
                for(var b = document.cookie.split(";"), c = 0; c < b.length; c++){
                    var d = Ib(b[c]);
                    d && d.hasOwnProperty("name") && Hb(d.name) && a(d.name, !1);
                }
            },
            isEnabled: function() {
                return navigator.cookieEnabled;
            }
        };
    }
    Fb.prototype.cookie = function() {
        return Kb();
    };
    Fb.prototype.pojo = {
        getAll: function() {
            return this.H;
        },
        get: function(a) {
            return this.H[a] || null;
        },
        set: function(a, b) {
            this.H[a] = b;
        },
        remove: function(a) {
            delete this.H[a];
        },
        clear: function() {
            this.H = {};
        },
        isEnabled: function() {
            return !0;
        }
    };
    function Lb() {}
    Lb.prototype.l = 0;
    function Mb(a, b, c) {
        if ("undefined" === typeof b) return "";
        var d = [];
        if (b instanceof Array) {
            for(a = 0; a < b.length; a++)d.push(encodeURIComponent(c) + "=" + encodeURIComponent(b[a]));
            return d.join("&");
        }
        for(var e in b)b.hasOwnProperty(e) && (b[e] instanceof Array || "object" === typeof b[e] ? d.push(Mb(a, b[e], c ? c + "." + e : e)) : d.push(encodeURIComponent(c ? c + "." + e : e) + "=" + encodeURIComponent(b[e])));
        return d.join("&");
    }
    function Nb(a, b, c) {
        var d, e = b.destination + b.endpoint, f = /^[0-9]{15,20}$/, m = /key_(live|test)_[A-Za-z0-9]{32}/;
        if ("undefined" !== typeof b.i) {
            for(g in b.i)if (b.i.hasOwnProperty(g)) {
                if (d = "function" === typeof b.i[g] ? b.i[g](b.endpoint, g, c[g]) : d) return {
                    error: d
                };
                e += "/" + c[g];
            }
        }
        var k = {};
        if ("undefined" !== typeof b.h && "/v1/pageview" !== b.endpoint && "/v1/dismiss" !== b.endpoint) {
            for(g in b.h)if (b.h.hasOwnProperty(g)) {
                if (d = b.h[g](b.endpoint, g, c[g])) return {
                    error: d
                };
                d = c[g];
                "undefined" !== typeof d && "" !== d && null !== d && (k[g] = d);
            }
        } else if ("/v1/pageview" === b.endpoint || "/v1/dismiss" === b.endpoint) D(k, c), k.branch_requestMetadata && delete k.branch_requestMetadata;
        c.hasOwnProperty("branch_requestMetadata") && c.branch_requestMetadata && "/v1/pageview" !== b.endpoint && "/v1/dismiss" !== b.endpoint && (k.metadata = w(c.branch_requestMetadata));
        c.branch_dma_data && (rb(k, c.branch_dma_data, b.endpoint), k.branch_dma_data && delete k.branch_dma_data);
        if ("POST" === b.method) try {
            var g = k;
            "undefined" === typeof g && (g = {});
            if (c.branch_key && m.test(c.branch_key)) g.branch_key = c.branch_key;
            else if (c.app_id && f.test(c.app_id)) g.app_id = c.app_id;
            else if (c.instrumentation) g.instrumentation = c.instrumentation;
            else throw Error(A("API request $1 missing parameter $2", [
                b.endpoint,
                "branch_key or app_id"
            ]));
        } catch (u) {
            return {
                error: u.message
            };
        }
        ("/v1/pageview" === b.endpoint || "/v1/dismiss" === b.endpoint) && k.metadata && (k.metadata = w(k.metadata || {}));
        "/v1/open" === b.endpoint && (k.options = w(k.options || {}));
        return {
            data: Mb(a, k, ""),
            url: e.replace(/^\//, "")
        };
    }
    Lb.prototype.createScript = function(a, b, c) {
        var d = document.createElement("script");
        d.type = "text/javascript";
        d.async = !0;
        d.src = a;
        J(d);
        a = document.getElementsByTagName("head");
        !a || 1 > a.length ? "function" === typeof b && b() : (a[0].appendChild(d), "function" === typeof b && Xa(d, "error", b), "function" === typeof c && Xa(d, "load", c));
    };
    function Ob(a, b, c, d, e) {
        var f = Date.now(), m = ua;
        0 === a.l && Pa() && a.l++;
        var k = "branch_callback__" + a.l++, g = 0 <= b.indexOf("branch.io") ? "&data=" : "&post_data=";
        c = "POST" === d ? encodeURIComponent(Da(h(c))) : "";
        var u = window.setTimeout(function() {
            window[k] = function() {};
            H(x, m, wa(f));
            e(Error("Request timed out"), null, 504);
        }, qa);
        window[k] = function(l) {
            window.clearTimeout(u);
            e(null, l);
        };
        a.createScript(b + (0 > b.indexOf("?") ? "?" : "") + (c ? g + c : "") + (0 <= b.indexOf("/c/") ? "&click=1" : "") + "&callback=" + k, function() {
            e(Error("Request blocked by client, probably adblock"), null);
        }, function() {
            H(x, m, wa(f));
            try {
                "function" === typeof this.remove ? this.remove() : this.parentNode.removeChild(this);
            } catch (l) {}
            delete window[k];
        });
    }
    function Pb(a, b, c, d, e, f, m, k) {
        var g = Date.now(), u = ua, l = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP");
        k && (l.responseType = k);
        l.ontimeout = function() {
            H(x, u, wa(g));
            f(Error("Request timed out"), null, 504);
        };
        l.onerror = function(p) {
            var q = "Error in API: URL - " + (l.responseURL || "Unknown") + ", Status - " + (l.status || "No status available") + ", Response - " + (l.responseText || "No response text available");
            console.log(q);
            f(Error(p.error || q), null, l.status);
        };
        l.onreadystatechange = function() {
            if (4 === l.readyState) {
                if (H(x, u, wa(g)), 200 === l.status) {
                    if ("arraybuffer" === l.responseType) var p = l.response;
                    else if (m) p = l.responseText;
                    else try {
                        p = v(l.responseText);
                    } catch (q) {
                        p = {};
                    }
                    f(null, p, l.status);
                } else if ("4" === l.status.toString().substring(0, 1) || "5" === l.status.toString().substring(0, 1)) l.responseURL && l.responseURL.includes("v2/event") ? f(l.responseText, null, l.status) : (p = "Error in API: URL - " + (l.responseURL || "Unknown") + ", Status - " + (l.status || "No status available") + ", Response - " + (l.responseText || "No response text available"), console.log(p), f(Error(p), null, l.status));
            }
        };
        try {
            l.open(d, b, !0), l.timeout = qa, l.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), l.send(c);
        } catch (p) {
            e.set("use_jsonp", !0), Ob(a, b, c, d, f);
        }
    }
    function Qb(a, b, c, d, e) {
        function f() {
            d.get("use_jsonp") || b.S ? Ob(a, l, c, b.method, m) : Pb(a, l, u, b.method, d, m, Y, n);
        }
        function m(r, G, E) {
            "function" === typeof a.fa && a.fa(l, b.method, p, r, E, G);
            r && 0 < q && "5" === (E || "").toString().substring(0, 1) ? (q--, window.setTimeout(function() {
                f();
            }, pa)) : e(r, G);
        }
        ua = b.endpoint + "-brtt";
        "/v1/url" === b.endpoint && 1 < Object.keys(x).length && (delete x["-brtt"], c.instrumentation = w(D({}, x)), x = {});
        if (z) for(var k = [
            "browser_fingerprint_id",
            "alternative_browser_fingerprint_id",
            "identity_id",
            "session_id",
            "identity"
        ], g = 0; g < k.length; g++)c.hasOwnProperty(k[g]) && delete c[k[g]];
        k = Nb(a, b, c);
        if (k.error) return e(Error(w({
            message: k.error,
            endpoint: b.endpoint,
            data: c
        })));
        var u = "";
        if ("GET" === b.method) var l = k.url + "?" + k.data;
        else l = k.url, u = k.data;
        var p;
        d.get("use_jsonp") || b.S ? p = c : p = u;
        var q = oa;
        if (z && Ba(l, c)) return Aa ? m(Error("Requested operation cannot be completed since tracking is disabled"), null, 300) : m(null, {}, 200);
        var Y = !1;
        if ("/v1/qr-code" === b.endpoint) {
            Y = !0;
            var n = "arraybuffer";
        }
        f();
    }
    function M(a) {
        a && a.parentNode && a.parentNode.removeChild(a);
    }
    function Rb(a, b) {
        a && !a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)")) && (a.className += " " + b);
    }
    function Sb(a) {
        var b = document.body;
        b && b.className.match(new RegExp("(\\s|^)" + a + "(\\s|$)")) && (b.className = b.className.replace(new RegExp("(\\s|^)" + a + "(\\s|$)"), " "));
    }
    function Tb(a) {
        var b = new Date;
        return b.setDate(b.getDate() + a);
    }
    function Ub(a) {
        return document.body.currentStyle ? document.body.currentStyle[Sa(a)] : window.getComputedStyle(document.body).getPropertyValue(a);
    }
    function Vb(a) {
        function b(c) {
            function d() {
                return Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 100;
            }
            function e() {
                return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) / 100;
            }
            if (!c) return 0;
            var f = c.replace(/[0-9,\.]/g, "");
            c = c.match(/\d+/g);
            var m = parseInt(0 < c.length ? c[0] : "0", 10);
            return parseInt(({
                px: function(k) {
                    return k;
                },
                em: function(k) {
                    return document.body.currentStyle ? k * b(document.body.currentStyle.fontSize) : k * parseFloat(window.getComputedStyle(document.body).fontSize);
                },
                rem: function(k) {
                    return document.documentElement.currentStyle ? k * b(document.documentElement.currentStyle.fontSize) : k * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
                },
                vw: function(k) {
                    return k * e();
                },
                vh: function(k) {
                    return k * d();
                },
                vmin: function(k) {
                    return k * Math.min(d(), e());
                },
                vmax: function(k) {
                    return k * Math.max(d(), e());
                },
                "%": function() {
                    return document.body.clientWidth / 100 * m;
                }
            })[f](m), 10);
        }
        return (b("76px") + b(a)).toString() + "px";
    }
    function Wb(a, b) {
        a = a.get("hideBanner", !0);
        if (b.ta && navigator && Number(navigator.doNotTrack)) return !1;
        try {
            "string" === typeof a && (a = v(a));
        } catch (d) {
            a = !1;
        }
        a = "number" === typeof a ? new Date >= new Date(a) : !a;
        var c = b.R;
        "number" === typeof c && (c = !1);
        return !document.getElementById("branch-banner") && !document.getElementById("branch-banner-iframe") && (a || c) && (b.V && "android" === F() || b.ua && "ipad" === F() || b.Z && "ios" === F() || b.W && "blackberry" === F() || b.Y && "windows_phone" === F() || b.X && "kindle" === F());
    }
    function Xb(a, b) {
        var c = ".branch-banner-is-active { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner { width:100%; z-index: 99999; font-family: Helvetica Neue, Sans-serif; -webkit-font-smoothing: antialiased; -webkit-user-select: none; -moz-user-select: none; user-select: none; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner .button{ border: 1px solid " + (a.buttonBorderColor || ("dark" === a.theme ? "transparent" : "#ccc")) + "; background: " + (a.buttonBackgroundColor || "#fff") + "; color: " + (a.buttonFontColor || "#000") + "; cursor: pointer; margin-top: 0px; font-size: 14px; display: inline-block; margin-left: 5px; font-weight: 400; text-decoration: none;  border-radius: 4px; padding: 6px 12px; transition: all .2s ease;}\n#branch-banner .button:hover {  border: 1px solid " + (a.buttonBorderColorHover || ("dark" === a.theme ? "transparent" : "#BABABA")) + "; background: " + (a.buttonBackgroundColorHover || "#E0E0E0") + "; color: " + (a.buttonFontColorHover || "#000") + ";}\n#branch-banner .button:focus { outline: none; }\n#branch-banner * { margin-right: 4px; position: relative; line-height: 1.2em; }\n#branch-banner-close { font-weight: 400; cursor: pointer; float: left; z-index: 2;padding: 0 5px 0 5px; margin-right: 0; }\n#branch-banner .content { width:100%; overflow: hidden; height: 76px; background: rgba(255, 255, 255, 0.95); color: #333; " + ("top" === a.position ? "border-bottom" : "border-top") + ': 1px solid #ddd; }\n#branch-banner-close { color: #000; font-size: 24px; top: 14px; opacity: .5; transition: opacity .3s ease; }\n#branch-banner-close:hover { opacity: 1; }\n#branch-banner .title { font-size: 18px; font-weight:bold; color: #555; }\n#branch-banner .description { font-size: 12px; font-weight: normal; color: #777; max-height: 30px; overflow: hidden; }\n#branch-banner .icon { float: left; padding-bottom: 40px; margin-right: 10px; margin-left: 5px; }\n#branch-banner .icon img { width: 63px; height: 63px; margin-right: 0; }\n#branch-banner .reviews { font-size:13px; margin: 1px 0 3px 0; color: #777; }\n#branch-banner .reviews .star { display:inline-block; position: relative; margin-right:0; }\n#branch-banner .reviews .star span { display: inline-block; margin-right: 0; color: #555; position: absolute; top: 0; left: 0; }\n#branch-banner .reviews .review-count { font-size:10px; }\n#branch-banner .reviews .star .half { width: 50%; overflow: hidden; display: block; }\n#branch-banner .content .left { padding: 6px 5px 6px 5px; }\n#branch-banner .vertically-align-middle { top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); }\n#branch-banner .details > * { display: block; }\n#branch-banner .content .left { height: 63px; }\n#branch-banner .content .right { float: right; height: 63px; margin-bottom: 50px; padding-top: 22px; z-index: 1; }\n#branch-banner .right > div { float: left; }\n#branch-banner-action { top: 17px; }\n#branch-banner .content:after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 1px; background: rgba(0, 0, 0, 0.2); }\n#branch-banner .theme-dark.content { background: rgba(51, 51, 51, 0.95); }\n#branch-banner .theme-dark #branch-banner-close{ color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .details { text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .title { color: #fff; }\n#branch-banner .theme-dark .description { color: #fff; }\n#branch-banner .theme-dark .reviews { color: #888; }\n#branch-banner .theme-dark .reviews .star span{ color: #fff; }\n#branch-banner .theme-dark .reviews .review-count{ color: #fff; }\n', d = F();
        "ios" !== d && "ipad" !== d || !a.Z ? "android" === d && a.V ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n#branch-banner #branch-banner-close,#branch-banner .theme-dark #branch-banner-close { height:17px; width: 17px; text-align: center; font-size: 15px; top: 24px;  border-radius:14px; border:0; line-height:14px; color:#b1b1b3; background:#efefef; padding: 0; opacity: 1; }\n#branch-banner .button { top: 0; text-decoration:none; border-bottom: 3px solid #A4C639; padding: 0 10px; height: 24px; line-height: 24px; text-align: center; color: #fff; margin-top: 2px;  font-weight: bold; background-color: #A4C639; border-radius: 5px; }\n#branch-banner .button:hover { border-bottom:3px solid #8c9c29; background-color: #c1d739; }\n" : "blackberry" === d && a.W ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n" : "windows_phone" === d && a.Y ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n" : "kindle" === d && a.X && (c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n") : c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n";
        c += a.la;
        a.M && (c += "body { margin: 0; }\n", d = document.createElement("style"), d.type = "text/css", d.id = "branch-iframe-css", J(d), d.innerHTML = "body { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: 76px; z-index: 99999; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner-iframe { position: " + (("top" !== a.position || a.pa ? "fixed" : "absolute") + "; }\n"), (document.head || document.getElementsByTagName("head")[0]).appendChild(d));
        d = document.createElement("style");
        d.type = "text/css";
        d.id = "branch-css";
        d.innerHTML = c;
        J(d);
        c = a.M ? b.contentWindow.document : document;
        (c = c.head || c.getElementsByTagName("head")[0]) && "function" === typeof c.appendChild && c.appendChild(d);
        "top" === a.position ? b.style.top = "-76px" : "bottom" === a.position && (b.style.bottom = "-76px");
    }
    function N(a, b) {
        try {
            var c = v(a.get(b ? "branch_session_first" : "branch_session", b)) || null;
            return Wa(c);
        } catch (d) {
            return null;
        }
    }
    function Fa(a, b, c) {
        c && b.referring_link && ya && (b.referringLinkExpiry = (new Date).getTime() + sa);
        b = Va(b);
        a.set("branch_session", h(b));
        c && a.set("branch_session_first", h(b), !0);
    }
    function Yb(a, b) {
        if (b) {
            var c = N(a) || {};
            b = h(Va(D(c, b)));
            a.set("branch_session", b);
        }
    }
    function Zb(a, b, c) {
        function d(f, m) {
            return Va(D(v(f), m, c));
        }
        var e = a.get("branch_session", !1) || {};
        a.set("branch_session", h(d(e, b)));
        e = a.get("branch_session_first", !0) || {};
        a.set("branch_session_first", h(d(e, b)), !0);
    }
    function $b(a, b, c) {
        var d = document.createElement("iframe");
        d.src = "about:blank";
        d.style.overflow = "hidden";
        d.scrolling = "no";
        d.id = "branch-banner-iframe";
        d.className = "branch-animation";
        J(d);
        d.onload = function() {
            var e = F(), f = d.contentDocument || d.contentWindow.document;
            f.head = f.createElement("head");
            f.body = f.createElement("body");
            f.body.className = "ios" === e || "ipad" === e ? "branch-banner-ios" : "android" === e ? "branch-banner-android" : "branch-banner-other";
            bc(a, b, f);
            c(d);
        };
        document.body.appendChild(d);
    }
    function bc(a, b, c) {
        c = c || document;
        var d = c.createElement("div");
        d.id = "branch-banner";
        d.className = "branch-animation";
        if (a.I || a.T) {
            if (a.I) {
                var e = "";
                for(var f = 0; 5 > f; f++)e += '<span class="star"><svg class="star" fill="#555555" height="12" viewBox="3 2 20 19" width="12"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="star">\u2606</span></foreignObject></svg>', a.I > f && (e += f + 1 > a.I && a.I % 1 ? '<span class="half"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12"><defs><path d="M0 0h24v24H0V0z" id="a"/></defs><clipPath id="b"><use overflow="visible" xlink:href="#a"/></clipPath><path clip-path="url(#b)" d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg><foreignObject display="none"><span class="half">\u2605</span></foreignObject></span>' : '<span class="full"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="full">\u2605</span></foreignObject></svg> </span>'), e += "</span>";
                e = '<span class="stars">' + e + "</span>";
            } else e = "";
            e = '<div class="reviews">' + e + (a.T ? '<span class="review-count">' + a.T + "</span>" : "") + "</div>";
        } else e = "";
        d.innerHTML = '<div class="content' + (a.theme ? " theme-" + a.theme : "") + '"><div class="right">' + b + '</div><div class="left">' + (a.ma ? "" : '<div id="branch-banner-close" class="branch-animation" aria-label="Close">&times;</div>') + '<div class="icon"><img src="' + a.icon + '" alt="Application icon"></div><div class="details vertically-align-middle"><div class="title">' + a.title + "</div>" + e + '<div class="description">' + a.description + "</div></div></div></div>";
        c.body.appendChild(d);
        return d;
    }
    function cc(a, b, c) {
        b = '<div id="branch-banner-form-container"><a id="branch-mobile-action" class="button" href="#" target="_parent">' + (((N(b) || {}).has_app ? a.qa : a.na) + "</a></div>");
        a.M ? $b(a, b, c) : (a = bc(a, b, document), c(a));
    }
    function dc(a, b, c, d) {
        function e(g, u) {
            "function" === typeof g && (u = g, g = {});
            g = g || {};
            "top" === b.position ? f.style.top = "-76px" : "bottom" === b.position && (f.style.bottom = "-76px");
            "number" === typeof b.R ? d.set("hideBanner", Tb(b.R), !0) : d.set("hideBanner", !0, !0);
            g.da ? ("top" === b.position ? document.body.style.marginTop = m : "bottom" === b.position && (document.body.style.marginBottom = k), Sb("branch-banner-is-active"), M(f), M(document.getElementById("branch-css")), u()) : (setTimeout(function() {
                M(f);
                M(document.getElementById("branch-css"));
                u();
            }, 270), setTimeout(function() {
                "top" === b.position ? document.body.style.marginTop = m : "bottom" === b.position && (document.body.style.marginBottom = k);
                Sb("branch-banner-is-active");
            }, 20));
        }
        if (!Wb(d, b)) return O(a, "willNotShowBanner"), null;
        O(a, "willShowBanner");
        var f, m = document.body.style.marginTop, k = document.body.style.marginBottom;
        cc(b, d, function(g) {
            function u() {
                "top" === b.position ? f.style.top = "0" : "bottom" === b.position && (f.style.bottom = "0");
                O(a, "didShowBanner");
            }
            f = g;
            Xb(b, f);
            c.channel = c.channel || "app banner";
            g = b.M ? f.contentWindow.document : document;
            if (![
                "other",
                "desktop"
            ].includes(F())) {
                b.open_app = b.ra;
                b.append_deeplink_path = b.ja;
                b.make_new_link = b.oa;
                b.deepview_type = "banner";
                a.deepview(c, b);
                var l = g.getElementById("branch-mobile-action");
                l && (l.onclick = function(q) {
                    q.preventDefault();
                    a.deepviewCta();
                });
            }
            l = Ub("margin-top");
            var p = Ub("margin-bottom");
            Rb(document.body, "branch-banner-is-active");
            "top" === b.position ? document.body.style.marginTop = Vb(l) : "bottom" === b.position && (document.body.style.marginBottom = Vb(p));
            if (l = g.getElementById("branch-banner-close")) l.onclick = function(q) {
                q.preventDefault();
                O(a, "willCloseBanner");
                e({}, function() {
                    O(a, "didCloseBanner");
                });
            };
            if (g = g.getElementById("branch-banner-modal-background")) g.onclick = function(q) {
                q.preventDefault();
                O(a, "willCloseBanner");
                e({}, function() {
                    O(a, "didCloseBanner");
                });
            };
            b.da ? u() : setTimeout(u, 20);
        });
        return e;
    }
    function ec() {
        function a() {
            if (b.length) b[0](function() {
                b.shift();
                a();
            });
        }
        var b = [];
        return function(c) {
            b.push(c);
            1 === b.length && a();
        };
    }
    var fc = {}, P, Q, R, gc, hc, ic, jc, kc, lc = 1;
    function mc() {
        P = "top";
        Q = "absolute";
        R = "76px";
        hc = gc = !1;
    }
    mc();
    var nc = [], oc = !1, pc = window.innerHeight, qc = window.innerWidth;
    window.innerHeight < window.innerWidth && (pc = window.innerWidth, qc = window.innerHeight);
    var rc = 0, sc = 0, tc = !1, uc = /<script type="application\/json">((.|\s)*?)<\/script>/, vc = /<script type="text\/javascript">((.|\s)*?)<\/script>/, wc = /<style type="text\/css" id="branch-css">((.|\s)*?)<\/style>/, xc = /<style type="text\/css" id="branch-iframe-css">((.|\s)*?)<\/style>/, yc = /#branch-banner-spacer {((.|\s)*?)}/, zc = /margin-bottom: (.*?);/, T = null, Ac = null, Bc = !1, Cc = !1, Dc = !1, Ec = !1, Fc = !1, Gc = "", Hc = [], U = null;
    function Ic(a) {
        mc();
        var b = Jc(a) || {};
        b && b.bannerHeight && b.position && b.sticky ? (R = b.bannerHeight, P = b.position, Q = b.sticky) : (a = a.match(yc)) ? (P = "top", (a = a[1].match(zc)) && (R = a[1]), Q = "absolute") : (P = "bottom", Q = "fixed");
        a = R;
        b = /vh|%/gi;
        if (a = b.test(a) ? a.replace(b, "") : !1) R = a / 100 * pc + "px", 100 > a ? hc = !0 : gc = !0;
    }
    function Jc(a) {
        if (a = a.match(uc)) return v(a[1]);
    }
    function Kc(a) {
        if (a = a.match(xc)) return a[1];
    }
    function Lc(a, b) {
        var c;
        b && a && a.ctaText && a.ctaText.has_app ? c = a.ctaText.has_app : a && a.ctaText && a.ctaText.no_app && (c = a.ctaText.no_app);
        return c;
    }
    function Mc(a) {
        nc = [];
        if (a && a.injectorSelector && (a = document.querySelectorAll(a.injectorSelector))) for(var b = 0; b < a.length; b++)nc.push(a[b].parentElement);
    }
    function Nc(a) {
        if (a = a.match(wc)) return a[1];
    }
    function Oc(a) {
        if (a = a.match(vc)) {
            a = a[1];
            var b = document.createElement("script");
            b.id = "branch-journey-cta";
            J(b);
            b.innerHTML = a;
            document.body.appendChild(b);
        }
    }
    function Pc(a) {
        var b = a.match(uc), c = a.match(vc), d = a.match(wc), e = a.match(xc);
        b && (a = a.replace(uc, ""));
        c && (a = a.replace(vc, ""));
        d && (a = a.replace(wc, ""));
        e && (a = a.replace(xc, ""));
        return a;
    }
    function Qc() {
        var a = document.createElement("iframe");
        a.src = "about:blank";
        a.style.overflow = "hidden";
        a.scrolling = "no";
        a.id = "branch-banner-iframe";
        a.className = "branch-animation";
        a.title = "Branch Banner Frame";
        a.setAttribute("aria-label", "Branch Banner Frame");
        J(a);
        return a;
    }
    function Rc(a) {
        var b = document.createElement("style");
        b.type = "text/css";
        b.id = "branch-iframe-css";
        rc = Ub("margin-top");
        var c = +rc.slice(0, -2);
        sc = Ub("margin-bottom");
        var d = +sc.slice(0, -2), e = +R.slice(0, -2);
        a || ("top" === P ? document.body.style.marginTop = (+e + c).toString() + "px" : "bottom" === P && (document.body.style.marginBottom = (+e + d).toString() + "px"));
        0 < nc.length && nc.forEach(function(f) {
            var m, k = window.getComputedStyle(f);
            k && (m = gc && "fixed" === k.getPropertyValue("position"));
            m || (f.style.marginTop = R);
        });
        "top" === Gc && Gc !== P && Fc && Hc && 0 < Hc.length && Hc.forEach(function(f) {
            f.style.marginTop = 0;
        });
        Fc = !1;
        Gc = "";
        Hc = [];
        Ec = !1;
        b.innerHTML = a ? a : Sc();
        J(b);
        document.head.appendChild(b);
    }
    function Sc() {
        var a = "", b = "";
        document.body.style.transition = "";
        document.getElementById("branch-banner-iframe") && (document.getElementById("branch-banner-iframe").style.transition = "");
        Dc || (a = "body { -webkit-transition: all 0.375s ease; }\n", document.body.style.transition = "all 00.375s ease", b = "-webkit-transition: all 0.25s ease; transition: all 00.25s ease;");
        a = a || "";
        if (ic) {
            var c = R, d = fc.va, e = Q;
            "overlay" === jc && (d = c = "100%!important", e = "fixed");
            a = a + ("#branch-banner-iframe-embed { z-index: 99999!important; height: " + c + "; width: " + d + "; padding: 0px!important; margin: 0px!important; ; position: " + e + "; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width: 100%; left: 0; right: 0; border: 0; height: 100%!important; width: 100%!important; ") + (b + "; position: " + e + "; }\n");
        } else a += "#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: " + R + "; z-index: 99999; " + b + " }\n#branch-banner-iframe { position: " + Q + "; }\n@media only screen and (orientation: landscape) { body { " + ("top" === P ? "margin-top: " : "margin-bottom: ") + (gc ? qc + "px" : R) + "; }\n#branch-banner-iframe { height: " + (gc ? qc + "px" : R) + "; }";
        return a;
    }
    function Tc(a, b) {
        Rb(document.body, "branch-banner-is-active");
        if (gc && "fixed" === Q) {
            var c = document.createElement("style");
            c.type = "text/css";
            c.innerHTML = ".branch-banner-no-scroll {overflow: hidden;}";
            document.head.appendChild(c);
            Rb(document.body, "branch-banner-no-scroll");
        }
        setTimeout(function() {
            b ? (a.style.top = null, a.style.bottom = null) : "top" === P ? a.style.top = "0" : "bottom" === P && (U && U.journey_link_data && !U.journey_link_data.safeAreaRequired ? a.style.bottom = "0" : (oc = !0, document.getElementById("branch-banner-iframe").style.transition = "all 0s", Uc(!1, !0), window.addEventListener("resize", Vc), window.addEventListener("scroll", Wc)));
            O(T, "didShowJourney", U);
            Bc = !0;
        }, 20);
    }
    function Vc() {
        oc && Uc(!1, !1);
    }
    function Wc() {
        oc && (window.pageYOffset > window.innerHeight ? Uc(!0, !1) : Uc(!1, !1));
    }
    function Uc(a, b) {
        var c = document.getElementById("branch-banner-iframe"), d = c.offsetHeight, e = c.offsetTop, f = window.innerHeight;
        b && 0 !== window.pageYOffset ? c.style.bottom = "0" : a ? c.style.top = f - d + d / 2 + "px" : f - e != d && (c.style.top = "" + (f - d) + "px");
    }
    function Xc(a) {
        a = a.globalDismissPeriod;
        if ("number" === typeof a) {
            if (-1 === a) a = !0;
            else {
                var b = new Date;
                a = b.setSeconds(b.getSeconds() + a);
            }
            return a;
        }
    }
    function Yc(a, b, c, d, e, f, m) {
        var k = V;
        d && e && (Array.prototype.forEach.call(e.contentWindow.document.querySelectorAll("#branch-mobile-action"), function(g) {
            g.addEventListener("click", function() {
                O(T, "didClickJourneyCTA", U);
                Ec = !0;
                d();
                Zc(e);
            });
        }), $c(".branch-banner-continue", "didClickJourneyContinue", c, e, a, b, f, m, k, "click"), $c(".branch-banner-close", "didClickJourneyClose", c, e, a, b, f, m, k, "click"), $c(".branch-banner-dismiss-background", "didClickJourneyBackgroundDismiss", c, e, a, b, f, m, k, "click"), $c(".branch-banner-dismiss-background", "didScrollJourneyBackgroundDismiss", c, e, a, b, f, m, k, "touchmove"));
    }
    function $c(a, b, c, d, e, f, m, k, g, u) {
        Array.prototype.forEach.call(d.contentWindow.document.querySelectorAll(a), function(l) {
            l.addEventListener(u, function() {
                ad(b, c, d, e, f, m, k, g);
            });
        });
    }
    function bd(a, b, c) {
        var d = a.get("journeyDismissals", !0);
        d = d ? v(d) : {};
        d[c] = {
            view_id: b,
            dismiss_time: Date.now()
        };
        a.set("journeyDismissals", w(d), !0);
    }
    function cd(a) {
        return void 0 === a || null === a ? null : a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&brvbar;/g, "\u00a6").replace(/&laquo;/g, "\u00ab").replace(/&acute;/g, "\u00b4").replace(/&middot;/g, "\u00b7").replace(/&raquo;/g, "\u00bb").replace(/&amp;/g, "&").replace(/&iquest;/g, "\u00bf").replace(/&times;/g, "\u00d7").replace(/&divide;/g, "\u00f7").replace(/&Agrave;/g, "\u00c0").replace(/&Aacute;/g, "\u00c1").replace(/&Acirc;/g, "\u00c2").replace(/&Atilde;/g, "\u00c3").replace(/&Auml;/g, "\u00c4").replace(/&Aring;/g, "\u00c5").replace(/&AElig;/g, "\u00c6").replace(/&Ccedil;/g, "\u00c7").replace(/&Egrave;/g, "\u00c8").replace(/&Eacute;/g, "\u00c9").replace(/&Ecirc;/g, "\u00ca").replace(/&Euml;/g, "\u00cb").replace(/&Igrave;/g, "\u00cc").replace(/&Iacute;/g, "\u00cd").replace(/&Icirc;/g, "\u00ce").replace(/&Iuml;/g, "\u00cf").replace(/&ETH;/g, "\u00d0").replace(/&Ntilde;/g, "\u00d1").replace(/&Ograve;/g, "\u00d2").replace(/&Oacute;/g, "\u00d3").replace(/&Ocirc;/g, "\u00d4").replace(/&Otilde;/g, "\u00d5").replace(/&Ouml;/g, "\u00d6").replace(/&Oslash;/g, "\u00d8").replace(/&Ugrave;/g, "\u00d9").replace(/&Uacute;/g, "\u00da").replace(/&Ucirc;/g, "\u00db").replace(/&Uuml;/g, "\u00dc").replace(/&Yacute;/g, "\u00dd").replace(/&THORN;/g, "\u00de").replace(/&szlig;/g, "\u00df").replace(/&agrave;/g, "\u00e0").replace(/&aacute;/g, "\u00e1").replace(/&acirc;/g, "\u00e2").replace(/&atilde;/g, "\u00e3").replace(/&auml;/g, "\u00e4").replace(/&aring;/g, "\u00e5").replace(/&aelig;/g, "\u00e6").replace(/&ccedil;/g, "\u00e7").replace(/&egrave;/g, "\u00e8").replace(/&eacute;/g, "\u00e9").replace(/&ecirc;/g, "\u00ea").replace(/&euml;/g, "\u00eb").replace(/&igrave;/g, "\u00ec").replace(/&iacute;/g, "\u00ed").replace(/&icirc;/g, "\u00ee").replace(/&iuml;/g, "\u00ef").replace(/&eth;/g, "\u00f0").replace(/&ntilde;/g, "\u00f1").replace(/&ograve;/g, "\u00f2").replace(/&oacute;/g, "\u00f3").replace(/&ocirc;/g, "\u00f4").replace(/&otilde;/g, "\u00f5").replace(/&ouml;/g, "\u00f6").replace(/&oslash;/g, "\u00f8").replace(/&ugrave;/g, "\u00f9").replace(/&uacute;/g, "\u00fa").replace(/&ucirc;/g, "\u00fb").replace(/&uuml;/g, "\u00fc").replace(/&yacute;/g, "\u00fd").replace(/&thorn;/g, "\u00fe").replace(/&yuml;/g, "\u00ff");
    }
    function dd(a, b) {
        var c = {}, d = Za();
        d && 0 < Object.keys(d).length && (c.hosted_deeplink_data = d);
        a = a.O(ed(null, c), null, T, !0);
        if (U && U.journey_link_data) {
            H(a, "journey_id", U.journey_link_data.journey_id);
            H(a, "journey_name", cd(U.journey_link_data.journey_name));
            H(a, "view_id", U.journey_link_data.view_id);
            H(a, "view_name", cd(U.journey_link_data.view_name));
            H(a, "channel", cd(U.journey_link_data.channel));
            H(a, "campaign", cd(U.journey_link_data.campaign));
            try {
                H(a, "tags", JSON.stringify(U.journey_link_data.tags));
            } catch (e) {
                a.tags = JSON.stringify([]);
            }
        }
        H(a, "dismissal_source", b);
        return a;
    }
    function ad(a, b, c, d, e, f, m, k) {
        var g = m ? 0 : Xc(f);
        O(T, a, U);
        Ec = !0;
        Zc(c);
        if (!m) {
            void 0 !== g && b.set("globalJourneysDismiss", g, !0);
            bd(b, d, e);
            var u = function() {
                T.removeListener(u);
                var l = dd(k, xa[a]);
                T.j(Cb, l, function(p, q) {
                    !p && f && f.dismissRedirect ? window.location = f.dismissRedirect : !p && "object" === typeof q && q.template && k.U(q, null, !1) && k.P(q.template, l, l.branch_view_id || q.event_data.branch_view_data.id, q.event_data.branch_view_data, !1, q.journey_link_data);
                });
            };
            T.addListener("branch_internal_event_didCloseJourney", u);
        }
    }
    function ed(a, b) {
        a = D({
            url: a && a.url || Ia(),
            user_agent: navigator.userAgent,
            language: navigator.language,
            screen_width: screen.width || -1,
            screen_height: screen.height || -1,
            window_device_pixel_ratio: window.devicePixelRatio || 1
        }, b || {});
        a = mb(a, "model", y ? y.model : "");
        return a = mb(a, "os_version", y ? y.platformVersion : "");
    }
    function Zc(a, b) {
        Cc || (tc = !0);
        if (Dc && !Cc) {
            document.body.style.transition = "all 00.375s ease";
            document.getElementById("branch-banner-iframe").style.transition = "all 00.25s ease";
            var c = document.getElementById("branch-iframe-css").innerHTML + "\n";
            c += "body { -webkit-transition: all 0.375s ease; }\n#branch-banner-iframe { -webkit-transition: all 0.25s ease; }\n";
            document.getElementById("branch-iframe-css").innerHTML = "";
            document.getElementById("branch-iframe-css").innerHTML = c;
        }
        "top" === P ? a.style.top = "-" + R : "bottom" === P && (a.style.bottom = "-" + R);
        O(T, "willCloseJourney", U);
        setTimeout(function() {
            M(a);
            M(document.getElementById("branch-css"));
            M(document.getElementById("branch-iframe-css"));
            M(document.getElementById("branch-journey-cta"));
            (!Cc || Ec) && nc && 0 < nc.length ? nc.forEach(function(d) {
                d.style.marginTop = 0;
            }) : (Fc = Cc, Gc = P, Hc = nc);
            "top" === P ? document.body.style.marginTop = rc : "bottom" === P && (document.body.style.marginBottom = sc);
            Sb("branch-banner-is-active");
            Sb("branch-banner-no-scroll");
            oc && (oc = !1, window.removeEventListener("resize", Vc), window.removeEventListener("scroll", Wc));
            O(T, "didCloseJourney", U);
            b || O(T, "branch_internal_event_didCloseJourney", U);
            Bc = !1;
            setTimeout(function() {
                tc = !1;
            }, 250);
        }, Cc ? 0 : 270);
    }
    function fd(a) {
        var b = {
            banner_id: kc
        };
        if (a && "object" === typeof a && 0 < Object.keys(a || {}).length) {
            var c = [
                "browser_fingerprint_id",
                "app_id",
                "source",
                "open_app",
                "link_click_id"
            ];
            if (a && "object" === typeof a && !Array.isArray(a) && 0 < Object.keys(a).length && c && Array.isArray(c) && 0 < c.length) for(var d in a)a.hasOwnProperty(d) && -1 < c.indexOf(d) && delete a[d];
            b.journey_link_data = {};
            D(b.journey_link_data, a);
        }
        U = b;
        ic = "desktop" === b.journey_link_data.type;
        jc = b.journey_link_data.variant || null;
    }
    function gd() {
        return fc && T && T.s && T.s.data ? T.s.data.$journeys_cta : !1;
    }
    function hd() {
        if (gd()) return T.s.data.$journeys_cta;
    }
    function id(a) {
        try {
            if (gd() && 0 < hd().length) return a.replace(/validate[(].+[)];/g, 'validate("' + hd() + '")').replace("window.top.location.replace(", "window.top.location = ");
        } catch (b) {}
        return a;
    }
    var V = {};
    function jd(a, b, c) {
        var d = b ? "OPEN" : "GET";
        Ic(a);
        var e = Jc(a);
        e && (d = Lc(e, b), Mc(e));
        var f = Nc(a);
        Oc(a);
        var m = Kc(a);
        a = Pc(a);
        b = document.createElement("div");
        b.id = "branch-banner-iframe-embed";
        var k = Qc();
        k.onload = function() {
            var g = a, u = F(), l = k.contentDocument || k.contentWindow.document;
            l.head = l.createElement("head");
            l.body = l.createElement("body");
            l.body.innerHTML = g;
            l.body.className = "ios" === u || "ipad" === u ? "branch-banner-ios" : "android" === u ? "branch-banner-android" : "branch-banner-other";
            (g = l.querySelector('meta[name="accessibility"]')) && "wcag" === g.content && (g = l.createElement("script"), g.type = "text/javascript", g.text = "\n\t\t\tvar focusableElements = 'button, [href], input, select, textarea, [role=\"button\"], h1, [role=\"text\"], .branch-banner-content';\n\t\t\tvar modal = document.getElementById('branch-banner');\n\t\t\tvar focusableContent = modal.querySelectorAll(focusableElements);\n\t\t\tvar focusElementIdx = 0;\n\n\t\t\tfunction handleKeyboardNavigation(e) {\n\t\t\t\tvar isTabPressed = e.key === 'Tab' || e.keyCode === 9;\n\t\t\t\tvar isEnterPressed = e.key === 'Enter' || e.keyCode === 13;\n\t\t\t\t\n\t\t\t\t// Handle Tab key for focus navigation\n\t\t\t\tif (isTabPressed) {\n\t\t\t\t\tif (e.shiftKey) {\n\t\t\t\t\t\tif (focusElementIdx <= 0) {\n\t\t\t\t\t\t\tfocusElementIdx = focusableContent.length - 1;\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tfocusElementIdx = focusElementIdx - 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t} else {\n\t\t\t\t\t\tif (focusElementIdx >= focusableContent.length - 1) {\n\t\t\t\t\t\t\tfocusElementIdx = 0;\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tfocusElementIdx = focusElementIdx + 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\tfocusableContent[focusElementIdx].focus();\n\t\t\t\t\te.preventDefault();\n\t\t\t\t\treturn;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t// Handle Enter key for activation\n\t\t\t\tif (isEnterPressed) {\n\t\t\t\t\t// Get the currently focused element\n\t\t\t\t\tvar focusedElement = document.activeElement;\n\t\t\t\t\tif (focusedElement && (\n\t\t\t\t\t\tfocusedElement.tagName === 'BUTTON' || \n\t\t\t\t\t\tfocusedElement.getAttribute('role') === 'button' ||\n\t\t\t\t\t\tfocusedElement.tagName === 'A'\n\t\t\t\t\t)) {\n\t\t\t\t\t\t// Simulate a click on the element\n\t\t\t\t\t\tfocusedElement.click();\n\t\t\t\t\t\te.preventDefault();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tfunction autoFocus(delay) {\n\t\t\t\tsetTimeout(function() { focusableContent[focusElementIdx].focus() }, delay);\n\t\t\t}\n\n\t\t\tdocument.addEventListener('keydown', handleKeyboardNavigation);\n\t\t\tautoFocus(100);\n\t\t\t\n\t\t", l.querySelector("body").append(g));
            Rc(m);
            g = document.createElement("style");
            g.type = "text/css";
            g.id = "branch-css";
            g.innerHTML = f;
            J(g);
            l = k.contentWindow.document;
            l.head.appendChild(g);
            g = ic && "overlay" === jc;
            if ((hc || gc) && !g) {
                var p = l.getElementsByClassName("branch-banner-content")[0];
                !l.getElementsByClassName("branch-banner-dismiss-background")[0] && p && (p.style.height = R);
            }
            "top" === P ? k.style.top = "-" + R : "bottom" === P && (k.style.bottom = "-" + R);
            try {
                p = l.getElementsByClassName("branch-banner-content")[0];
                var q = window.getComputedStyle(p).getPropertyValue("background-color").split(", ");
                q[3] && 0 === parseFloat(q[3]) && (k.style.boxShadow = "none");
            } catch (Y) {}
            p = d;
            (q = k.contentWindow.document) && q.getElementById("branch-mobile-action") && (q = q.getElementById("branch-mobile-action"), q.innerHTML = p, q.setAttribute("aria-label", p));
            p = Object.assign({}, U);
            p.bannerHeight = R;
            p.isFullPageBanner = gc;
            p.bannerPagePlacement = P;
            p.isBannerInline = "absolute" === Q;
            p.isBannerSticky = "fixed" === Q;
            O(T, "willShowJourney", p);
            Tc(k, m);
            c(k);
        };
        ic ? (b.appendChild(k), document.body.appendChild(b)) : document.body.prepend(k);
    }
    V.U = function(a, b, c) {
        if (document.getElementById("branch-banner") || document.getElementById("branch-banner-iframe") || document.getElementById("branch-banner-container") || "other" == F() || !a.event_data || !a.template) return !1;
        if (c) return !0;
        (a = !a.event_data.branch_view_data.id || b && b.no_journeys) || (a = T, b = a.g.get("globalJourneysDismiss", !0), !0 === b || b > Date.now() ? a = !0 : (a.g.remove("globalJourneysDismiss", !0), a = !1));
        return a ? (V.Ca = 1, !1) : !0;
    };
    V.P = function(a, b, c, d, e, f) {
        if (!tc) {
            kc = c;
            fd(f);
            var m = d.audience_rule_id;
            (d = document.getElementById("branch-iframe-css")) && d.parentElement && d.parentElement.removeChild(d);
            var k = document.createElement("div");
            k.id = "branch-banner";
            document.body.insertBefore(k, null);
            Rb(k, "branch-banner-is-active");
            var g = !1, u = b.callback_string, l = null, p = T.g;
            if (a) {
                var q = Jc(a) || {};
                a = id(a);
                var Y = window.setTimeout(function() {
                    window[u] = function() {};
                }, qa);
                window[u] = function(n) {
                    window.clearTimeout(Y);
                    g || (l = n, Yc(c, m, p, l, null, q, e));
                };
                jd(a, b.has_app_websdk, function(n) {
                    Ac = n;
                    null === n ? g = !0 : (Yc(c, m, p, l, n, q, e), ta && (x["journey-load-time"] = (Date.now() - window.performance.timing.navigationStart).toString()), document.body.removeChild(k));
                });
            } else document.body.removeChild(k);
        }
    };
    V.O = function(a, b, c, d) {
        T = c;
        b || (b = {});
        a || (a = {});
        Dc = b.disable_entry_animation || !1;
        Cc = b.disable_exit_animation || !1;
        var e = D({}, c.s), f = N(c.g) || {}, m = f.hasOwnProperty("has_app") ? f.has_app : !1, k = f.hasOwnProperty("identity") ? f.identity : null, g = c.g.get("journeyDismissals", !0), u = (b.user_language || $a() || "en").toLowerCase() || null, l = nb(W(c)), p;
        (p = b.branch_view_id) || (p = "_branch_view_id".replace(/[\[\]]/g, "\\$&"), p = (p = new RegExp("[?&]" + p + "(=([^&#]*)|&|#|$)").exec(Ia())) && p[2] ? decodeURIComponent(p[2].replace(/\+/g, " ")) : "");
        p = p || null;
        c = b.make_new_link ? null : Ka(W(c, !0));
        var q = f.hasOwnProperty("session_link_click_id") ? f.session_link_click_id : null;
        e.event = d ? "dismiss" : "pageview";
        e.metadata = a;
        e = H(e, "initial_referrer", l);
        e = H(e, "branch_view_id", p);
        e = H(e, "no_journeys", b.no_journeys);
        e = H(e, "is_iframe", B());
        e = H(e, "journey_dismissals", g);
        e = H(e, "identity", k);
        e = H(e, "session_link_click_id", q);
        e.user_language = u;
        e.open_app = b.open_app || !1;
        e.has_app_websdk = m;
        e.feature = "journeys";
        e.callback_string = "branch_view_callback__" + lc++;
        e.data || (e.data = {});
        e.data = D(Za(), e.data);
        e.data = D(Ha(f || {}), e.data);
        c && (e.data.link_click_id = c);
        (a = f.data ? v(f.data) : null) && a["+referrer"] && (e.data["+referrer"] = a["+referrer"]);
        e.session_referring_link_data = f.data || null;
        return e = Ja(e);
    };
    var kd;
    function X(a, b, c) {
        return function() {
            var d = this, e = arguments[arguments.length - 1];
            if (0 === a || "function" !== typeof e) {
                var f = function() {};
                var m = Array.prototype.slice.call(arguments);
            } else m = Array.prototype.slice.call(arguments, 0, arguments.length - 1) || [], f = e;
            d.ha(function(k) {
                function g(u, l) {
                    try {
                        if (u && 0 === a) throw u;
                        1 === a ? f(u) : 2 === a && f(u, l);
                    } finally{
                        k();
                    }
                }
                if (!c) {
                    if (1 === d.A) return g(Error(A("Branch SDK initialization pending and a Branch method was called outside of the queue order")), null);
                    if (2 === d.A) return g(Error(A("Branch SDK initialization failed, so further methods cannot be called", d.B, d.D)), null);
                    if (0 === d.A || !d.A) return g(Error(A("Branch SDK not initialized")), null);
                }
                m.unshift(g);
                b.apply(d, m);
            });
        };
    }
    function Z() {
        if (!(this instanceof Z)) return kd || (kd = new Z), kd;
        this.ha = ec();
        this.g = new Fb;
        this.$ = new Lb;
        this.u = [];
        this.ca = "web2.87.1";
        this.l = {};
        this.B = this.A = 0;
        this.D = null;
    }
    Z.prototype.j = function(a, b, c) {
        this.aa && (b.app_id = this.aa);
        this.o && (b.branch_key = this.o);
        (a.h && a.h.session_id || a.i && a.i.session_id) && this.J && (b.session_id = this.J);
        (a.h && a.h.identity_id || a.i && a.i.identity_id) && this.v && (b.identity_id = this.v);
        0 > a.endpoint.indexOf("/v1/") ? (a.h && a.h.developer_identity || a.i && a.i.developer_identity) && this.m && (b.developer_identity = this.m) : (a.h && a.h.identity || a.i && a.i.identity) && this.m && (b.identity = this.m);
        (a.h && a.h.link_click_id || a.i && a.i.link_click_id) && this.ea && (b.link_click_id = this.ea);
        (a.h && a.h.sdk || a.i && a.i.sdk) && this.ca && (b.sdk = this.ca);
        (a.h && a.h.browser_fingerprint_id || a.i && a.i.browser_fingerprint_id) && this.L && (b.browser_fingerprint_id = this.L);
        z && (b.tracking_disabled = z);
        if (this.l) for(var d in this.l)this.l.hasOwnProperty(d) && (b.branch_requestMetadata || (b.branch_requestMetadata = {}), b.branch_requestMetadata[d] = this.l[d]);
        va.hasOwnProperty(a.endpoint) && (d = this.g.get("branch_dma_data", !0), b.branch_dma_data = d ? v(d) : null);
        "/_r" !== a.endpoint && (a.destination = t);
        return Qb(this.$, a, b, this.g, function(e, f) {
            c(e, f);
        });
    };
    function W(a, b) {
        var c = N(a.g);
        if (c = c && c.referring_link) return c;
        if (ya && b && (b = (c = N(a.g, !0)) && c.referring_link, c = c && c.referringLinkExpiry, b && c)) {
            if ((new Date).getTime() > c) Zb(a.g, {
                referringLinkExpiry: null
            }, !0);
            else return b;
        }
        return (a = a.g.get("click_id")) ? "https://bnc.lt/c/" + a : null;
    }
    function O(a, b, c) {
        for(var d = 0; d < a.u.length; d++)a.u[d].event && a.u[d].event !== b || a.u[d].listener(b, c);
    }
    Z.prototype.init = X(2, function(a, b, c) {
        function d() {
            if ("undefined" !== typeof document.hidden) {
                var n = "hidden";
                var r = "visibilitychange";
            } else "undefined" !== typeof document.mozHidden ? (n = "mozHidden", r = "mozvisibilitychange") : "undefined" !== typeof document.msHidden ? (n = "msHidden", r = "msvisibilitychange") : "undefined" !== typeof document.webkitHidden && (n = "webkitHidden", r = "webkitvisibilitychange");
            r && !g.ka && (g.ka = !0, document.addEventListener(r, function() {
                document[n] || (m(null), "function" === typeof g.G && g.G());
            }, !1));
        }
        function e(n, r) {
            r && (r = k(r), z || (r = f(r), Fa(g.g, r, p)), g.A = 3, r.data_parsed = r.data && 0 !== r.data.length ? v(r.data) : {});
            if (n) return g.A = 2, g.B || (g.B = 1, g.D = n.message), a(n, r && Ga(r));
            try {
                a(n, r && Ga(r));
            } catch (E) {} finally{
                g.renderFinalize();
            }
            n = gb();
            (r = I(c.metadata, "object") ? c.metadata : null) && (r = ob(n.hosted_deeplink_data, r)) && 0 < Object.keys(r).length && (n.hosted_deeplink_data = r);
            var G = V.O(ed(c, n), c, g, !1);
            g.renderQueue(function() {
                g.j(Bb, G, function(E, S) {
                    E || "object" !== typeof S || (E = G.branch_view_id ? !0 : !1, V.U(S, c, E) ? V.P(S.template, G, G.branch_view_id || S.event_data.branch_view_data.id, S.event_data.branch_view_data, E, S.journey_link_data) : ((S.auto_branchify || !u && Ra("branchify_url") && W(g)) && this.branch.deepview({}, {
                        make_new_link: !1,
                        open_app: !0,
                        auto_branchify: !0
                    }), O(T, "willNotShowJourney")));
                    z && (Aa = !0);
                });
            });
        }
        function f(n) {
            p && (n.identity = g.m);
            return n;
        }
        function m(n) {
            var r = {
                sdk: "2.87.1",
                branch_key: g.o
            }, G = N(g.g) || {}, E = N(g.g, !0) || {};
            E.browser_fingerprint_id && (r._t = E.browser_fingerprint_id);
            Pa() || Qa() || g.j(vb, r, function(S, ac) {
                S && (g.B = 3, g.D = S.message);
                ac && (G.browser_fingerprint_id = ac);
            });
            n && n(null, G);
        }
        function k(n) {
            n.link_click_id && (g.ea = n.link_click_id.toString());
            n.session_link_click_id && (g.Ga = n.session_link_click_id.toString());
            n.session_id && (g.J = n.session_id.toString());
            n.identity_id && (g.v = n.identity_id.toString());
            n.identity && (g.m = n.identity.toString());
            n.link && (g.ga = n.link);
            if (n.referring_link) {
                var r = n.referring_link;
                n.referring_link = r ? "http" !== r.substring(0, 4) ? "https://bnc.lt" + r : r : null;
            }
            !n.click_id && n.referring_link && (n.click_id = Ka(n.referring_link));
            g.L = n.browser_fingerprint_id;
            return n;
        }
        ta && (x["init-began-at"] = (Date.now() - window.performance.timing.navigationStart).toString());
        var g = this;
        g.A = 1;
        -1 < b.indexOf("key_") ? g.o = b : g.aa = b;
        c = c && I(c, "object") ? c : {};
        oa = (g.N = c) && c.retries && Number.isInteger(c.retries) ? c.retries : oa;
        pa = c && c.retry_delay && Number.isInteger(c.retry_delay) ? c.retry_delay : pa;
        qa = c && c.timeout && Number.isInteger(c.timeout) ? c.timeout : qa;
        ra = c && c.nonce ? c.nonce : ra;
        na = c && c.enableLogging ? c.enableLogging : na;
        z = c && c.tracking_disabled && !0 === c.tracking_disabled ? !0 : !1;
        ya = c && c.enableExtendedJourneysAssist ? c.enableExtendedJourneysAssist : ya;
        sa = c && c.extendedJourneysAssistExpiryTime && Number.isInteger(c.extendedJourneysAssistExpiryTime) ? c.extendedJourneysAssistExpiryTime : sa;
        Aa = !1;
        qb();
        z && Ea(g);
        b = N(g.g, !0);
        g.v = b && b.identity_id;
        b = N(g.g);
        var u = c && "undefined" !== typeof c.branch_match_id && null !== c.branch_match_id ? c.branch_match_id : null, l = u || Ra("_branch_match_id") || La(), p = !g.v;
        g.K = !!g.g.get("branch_view_enabled");
        if (b && b.session_id && !l && !Ra("branchify_url")) Yb(g.g, {
            data: ""
        }), Yb(g.g, {
            referring_link: ""
        }), d(), m(e);
        else {
            b = {
                sdk: "2.87.1",
                branch_key: g.o
            };
            var q = N(g.g, !0) || {};
            q.browser_fingerprint_id && (b._t = q.browser_fingerprint_id);
            q.identity && (g.m = q.identity);
            var Y = parseInt(Ra("[?&]_open_delay_ms"), 10);
            Pa() || Qa() ? pb(function() {
                g.j(ub, {
                    link_identifier: l,
                    browser_fingerprint_id: l || q.browser_fingerprint_id,
                    identity: q.identity ? q.identity : null,
                    alternative_browser_fingerprint_id: q.browser_fingerprint_id,
                    options: c,
                    initial_referrer: nb(W(g)),
                    current_url: B() && Ma() ? window.top.location.href : window.location.href,
                    screen_height: screen.height || 0,
                    screen_width: screen.width || 0,
                    model: y ? y.model : null,
                    os_version: y ? y.platformVersion : null
                }, function(n, r) {
                    n && (g.B = 2, g.D = n.message);
                    n || "object" !== typeof r || (r.branch_view_enabled && (g.K = !!r.branch_view_enabled, g.g.set("branch_view_enabled", g.K)), l && (r.click_id = l));
                    d();
                    e(n, r);
                });
            }, Y) : g.j(vb, b, function(n, r) {
                if (n) return g.B = 3, g.D = n.message, e(n, null);
                pb(function() {
                    g.j(ub, {
                        link_identifier: l,
                        browser_fingerprint_id: l || r,
                        identity: q.identity ? q.identity : null,
                        alternative_browser_fingerprint_id: q.browser_fingerprint_id,
                        options: c,
                        initial_referrer: nb(W(g)),
                        current_url: B() && Ma() ? window.top.location.href : window.location.href,
                        screen_height: screen.height || 0,
                        screen_width: screen.width || 0,
                        model: y ? y.model : null,
                        os_version: y ? y.platformVersion : null
                    }, function(G, E) {
                        G && (g.B = 2, g.D = G.message);
                        G || "object" !== typeof E || (E.branch_view_enabled && (g.K = !!E.branch_view_enabled, g.g.set("branch_view_enabled", g.K)), l && (E.click_id = l));
                        d();
                        e(G, E);
                    });
                }, Y);
            });
        }
    }, !0);
    Z.prototype.renderQueue = X(0, function(a, b) {
        this.ia ? b() : (this.C = this.C || [], this.C.push(b));
        a(null, null);
    });
    Z.prototype.renderFinalize = X(2, function(a) {
        this.C && 0 < this.C.length && (this.C.forEach(function(b) {
            b.call(this);
        }), delete this.C);
        this.ia = !0;
        a(null, null);
    });
    Z.prototype.data = X(2, function(a) {
        var b = Ga(N(this.g));
        b.referring_link = W(this);
        b.data_parsed = b.data && 0 !== b.data.length ? v(b.data) : {};
        a(null, b);
    });
    Z.prototype.first = X(2, function(a) {
        a(null, Ga(N(this.g, !0)));
    });
    Z.prototype.setIdentity = X(2, function(a, b) {
        if (b) {
            var c = {
                v: this.v,
                J: this.J,
                link: this.ga,
                Ea: b
            };
            this.m = b;
            Zb(this.g, {
                identity: b
            });
            a(null, c);
        } else a(Error(A("setIdentity - required argument identity should have a non-null value")));
    });
    Z.prototype.logout = X(1, function(a) {
        this.m = null;
        Zb(this.g, {
            identity: null
        }, !0);
        a(null);
    });
    Z.prototype.getBrowserFingerprintId = X(2, function(a) {
        var b = N(this.g, !0) || {};
        a(null, b.browser_fingerprint_id || null);
    });
    Z.prototype.crossPlatformIds = X(2, function(a) {
        this.j(Db, {
            user_data: w(lb(this))
        }, function(b, c) {
            return a(b || null, c && c.user_data || null);
        });
    });
    Z.prototype.lastAttributedTouchData = X(2, function(a, b) {
        b = I(b, "number") ? b : null;
        var c = lb(this);
        H(c, "attribution_window", b);
        this.j(Eb, {
            user_data: w(c)
        }, function(d, e) {
            return a(d || null, e || null);
        });
    });
    Z.prototype.track = X(1, function(a, b, c, d) {
        c = c || {};
        d = d || {};
        ra = d.nonce ? d.nonce : ra;
        if ("pageview" === b) {
            (b = ob(Za(), c)) && 0 < Object.keys(b).length && (c.hosted_deeplink_data = b);
            var e = V.O(ed(d, c), d, this, !1);
            this.j(Bb, e, function(f, m) {
                if (!f && "object" === typeof m) {
                    var k = e.branch_view_id ? !0 : !1;
                    V.U(m, d, k) ? V.P(m.template, e, e.branch_view_id || m.event_data.branch_view_data.id, m.event_data.branch_view_data, k, m.journey_link_data) : O(T, "willNotShowJourney");
                }
                "function" === typeof a && a.apply(this, arguments);
            });
        } else console.warn("track method currently supports only pageview event.");
    });
    Z.prototype.logEvent = X(1, function(a, b, c, d, e) {
        b = I(b, "string") ? b : null;
        c = I(c, "object") ? c : null;
        e = I(e, "string") ? e : null;
        c = jb(c);
        b && -1 < hb.indexOf(b) ? (d = I(d, "array") ? d : null, this.j(zb, {
            name: b,
            user_data: w(lb(this)),
            custom_data: w(c && c.custom_data || {}),
            event_data: w(c && c.event_data || {}),
            content_items: w(d || []),
            customer_event_alias: e
        }, function(f) {
            return a(f || null);
        })) : this.j(Ab, {
            name: b,
            user_data: w(lb(this)),
            custom_data: w(c && c.custom_data || {}),
            event_data: w(c && c.event_data || {}),
            content_items: w(d || []),
            customer_event_alias: e
        }, function(f) {
            return a(f || null);
        });
    });
    Z.prototype.link = X(2, function(a, b) {
        var c = Ja(b), d = this.o;
        this.j(wb, c, function(e, f) {
            if (e) return a(e, Ca(d, c));
            a(null, f && f.url);
        });
    });
    Z.prototype.qrCode = X(2, function(a, b, c) {
        Ja(b).qr_code_settings = w(kb(c || {}));
        this.j(xb, Ja(b), function(d, e) {
            function f() {}
            d || (f.rawBuffer = e, f.base64 = function() {
                if (this.rawBuffer) {
                    const m = Array.from(new Uint8Array(e)).map((k)=>String.fromCharCode(k)).join("");
                    return btoa(m);
                }
                throw Error("QrCode.rawBuffer is empty.");
            });
            return a(d || null, f || null);
        });
    });
    Z.prototype.deepview = X(1, function(a, b, c) {
        var d = this;
        c || (c = {});
        c.deepview_type = "undefined" === typeof c.deepview_type ? "deepview" : "banner";
        b.data = D(Za(), b.data);
        b = B() ? D({
            is_iframe: !0
        }, b) : b;
        b = Ja(b);
        var e = Ca(this.o, b);
        if (c.open_app || null === c.open_app || "undefined" === typeof c.open_app) b.open_app = !0;
        b.append_deeplink_path = !!c.append_deeplink_path;
        b.deepview_type = c.deepview_type;
        var f = W(d);
        f && !c.make_new_link && (b.link_click_id = Ka(f));
        b.banner_options = c;
        c.auto_branchify && (b.auto_branchify = !0);
        d.G = ha(this.j, d, yb, b, function(m, k) {
            if (m) return z || (d.F = function() {
                window.top.location = e;
            }), a(m);
            "function" === typeof k && (d.F = k);
            a(null);
        });
        d.G();
    });
    Z.prototype.deepviewCta = X(1, function(a) {
        if ("undefined" === typeof this.F) return z ? a(Error("Requested operation cannot be completed since tracking is disabled"), null) : a(Error("Cannot call Deepview CTA, please call branch.deepview() first"), null);
        window.event && (window.event.preventDefault ? window.event.preventDefault() : window.event.returnValue = !1);
        O(this, "didDeepviewCTA");
        this.F();
        a();
    });
    Z.prototype.addListener = function(a, b) {
        "function" === typeof a && void 0 === b && (b = a, a = null);
        b && this.u.push({
            listener: b,
            event: a || null
        });
    };
    Z.prototype.removeListener = function(a) {
        a && (this.u = this.u.filter(function(b) {
            if (b.listener !== a) return b;
        }));
    };
    function ld(a, b, c) {
        c = c || {};
        try {
            a.s = v(w(c));
        } finally{
            a.s = a.s || {};
        }
        b();
    }
    Z.prototype.setBranchViewData = X(1, function(a, b) {
        ld.call(null, this, a, b);
    }, !0);
    Z.prototype.closeJourney = X(1, function(a) {
        var b = this;
        b.renderQueue(function() {
            if (Ac && Bc) O(b, "didCallJourneyClose", U), Zc(Ac, !0);
            else return a("Journey already dismissed.");
        });
        a();
    });
    Z.prototype.banner = X(1, function(a, b, c) {
        console.warn('The "banner" method is deprecated and will be removed in future versions. Please use Branch Journeys instead. For more information and migration steps, visit: https://help.branch.io/using-branch/docs/journeys-overview');
        if ([
            "other",
            "desktop"
        ].includes(F())) console.info("banner functionality is not supported on this platform");
        else {
            c = c || {};
            ld.call(null, this, function() {}, c);
            "undefined" === typeof b.showAgain && "undefined" !== typeof b.forgetHide && (b.showAgain = b.forgetHide);
            var d = {
                icon: fb(b.icon) || "",
                title: fb(b.title) || "",
                description: fb(b.description) || "",
                T: "number" === typeof b.reviewCount && 0 < b.reviewCount ? Math.floor(b.reviewCount) : null,
                I: "number" === typeof b.rating && 5 >= b.rating && 0 < b.rating ? Math.round(2 * b.rating) / 2 : null,
                qa: fb(b.openAppButtonText) || "View in app",
                na: fb(b.downloadAppButtonText) || "Download App",
                M: "undefined" === typeof b.iframe ? !0 : b.iframe,
                Z: "undefined" === typeof b.showiOS ? !0 : b.showiOS,
                ua: "undefined" === typeof b.showiPad ? !0 : b.showiPad,
                V: "undefined" === typeof b.showAndroid ? !0 : b.showAndroid,
                W: "undefined" === typeof b.showBlackberry ? !0 : b.showBlackberry,
                Y: "undefined" === typeof b.showWindowsPhone ? !0 : b.showWindowsPhone,
                X: "undefined" === typeof b.showKindle ? !0 : b.showKindle,
                ma: !!b.disableHide,
                R: "number" === typeof b.forgetHide ? b.forgetHide : !!b.forgetHide,
                ta: "undefined" === typeof b.respectDNT ? !1 : b.respectDNT,
                position: b.position || "top",
                la: b.customCSS || "",
                pa: "undefined" === typeof b.mobileSticky ? !1 : b.mobileSticky,
                ya: b.buttonBorderColor || "",
                wa: b.buttonBackgroundColor || "",
                Aa: b.buttonFontColor || "",
                za: b.buttonBorderColorHover || "",
                xa: b.buttonBackgroundColorHover || "",
                Ba: b.buttonFontColorHover || "",
                oa: !!b.make_new_link,
                ra: !!b.open_app,
                da: !!b.immediate,
                ja: !!b.append_deeplink_path
            };
            "undefined" !== typeof b.showMobile && (d.Z = b.showMobile, d.V = b.showMobile, d.W = b.showMobile, d.Y = b.showMobile, d.X = b.showMobile);
            c.data = D(Za(), c.data);
            var e = this;
            e.renderQueue(function() {
                e.ba = dc(e, d, c, e.g);
            });
        }
        a();
    });
    Z.prototype.closeBanner = X(0, function(a) {
        var b = this;
        b.renderQueue(function() {
            b.ba && (O(b, "willCloseBanner"), b.ba(function() {
                O(b, "didCloseBanner");
            }));
        });
        a();
    });
    Z.prototype.trackCommerceEvent = X(1, function(a, b, c, d) {
        var e = this;
        e.renderQueue(function() {
            var f = eb(b, c);
            if (f) return a(Error(f));
            e.j(sb.Da, {
                event: b,
                metadata: D({
                    url: document.URL,
                    user_agent: navigator.userAgent,
                    language: navigator.language
                }, d || {}),
                initial_referrer: nb(W(e)),
                commerce_data: c
            }, function(m) {
                a(m || null);
            });
        });
        a();
    });
    Z.prototype.disableTracking = X(1, function(a, b) {
        if (!1 === b || "false" === b) Aa = z = !1, this.o && this.N && (!0 === this.N.tracking_disabled && delete this.N.tracking_disabled, this.init(this.o, this.N));
        else if (void 0 === b || !0 === b || "true" === b) Ea(this), Aa = z = !0, this.closeBanner(), this.closeJourney();
        a();
    }, !0);
    Z.prototype.setAPIResponseCallback = X(0, function(a, b) {
        this.$.fa = b;
        a();
    }, !0);
    Z.prototype.referringLink = function(a) {
        return W(this, a);
    };
    Z.prototype.setDMAParamsForEEA = X(1, function(a, b, c, d) {
        try {
            var e = (f, m)=>!0 !== f && !1 !== f ? (console.warn(`setDMAParamsForEEA: ${m} must be boolean, but got ${f}`), !1) : !0;
            if (!(e(b, "eeaRegion") && e(c, "adPersonalizationConsent") && e(d, "adUserDataUsageConsent"))) return;
            e = {};
            e.eeaRegion = b;
            e.adPersonalizationConsent = c;
            e.adUserDataUsageConsent = d;
            this.g.set("branch_dma_data", w(e), !0);
        } catch (f) {
            console.error("setDMAParamsForEEA::An error occurred while setting DMA parameters for EEA", f);
        }
        a();
    }, !0);
    Z.prototype.setRequestMetaData = function(a, b) {
        try {
            "undefined" !== typeof a && null !== a && 0 !== a.length && "undefined" !== typeof b && (this.l.hasOwnProperty(a) && null === b && delete this.l[a], this.l = H(this.l, a, b));
        } catch (c) {
            console.error("An error occured while setting request metadata", c);
        }
    };
    Z.prototype.setAPIUrl = function(a) {
        a && "" !== a.trim() && RegExp("^(https?)://((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").test(a) ? t = a : console.error("setAPIUrl: Invalid URL format. Default URL will be set.");
    };
    Z.prototype.getAPIUrl = function() {
        return t;
    };
    var md = new Z;
    if (window.branch && window.branch._q) for(var nd = window.branch._q, od = 0; od < nd.length; od++){
        var pd = nd[od];
        md[pd[0]].apply(md, pd[1]);
    }
    "function" === typeof define && define.amd ? define("branch", function() {
        return md;
    }) : $218711fccd48f794$exports = md;
    window && (window.branch = md);
})();



var $jPxhr = parcelRequire("jPxhr");

var $i2HuG = parcelRequire("i2HuG");

(parcelRequire("8vghX")).config();
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    const verifyModal = document.getElementById('verifyModal');
    const verifyTopLabel = document.getElementById('verifyTopLabel');
    const verifyPhoneTextField = document.getElementById('verifyPhoneTextField');
    const resendCodeButton = document.getElementById('resendCodeButton');
    const verifySmsButton = document.getElementById('verifySmsButton');
    const closeVerifyButton = document.getElementById('closeVerifyButton');
    var initialoffer;
    var initialamount;
    var locationObject = await (0, $kcvY9.LocationObject)();
    // MARK: - BRANCH LINK
    $218711fccd48f794$exports.init("key_live_dxyBr1GWcuRxesLUgnBKDghpwuakYwXN", function(err, data) {
        const linkData = JSON.parse(data.data);
        if (linkData != null) handleDeeplink(linkData);
    });
    function handleDeeplink(linkData) {
        const deepLinkPath = linkData.$deeplink_path;
        if (deepLinkPath != null) {
            const currentUser = (0, $03cFT.default).User.current();
            if (deepLinkPath.includes('initialoffer')) handleInitialOffer();
            if (deepLinkPath.includes('referid')) {
                const referid = deepLinkPath.slice(-10);
                if (currentUser.get('anonymous') == false) alert('You are already signed into an account');
                else {
                    sessionStorage.setItem('referid', referid);
                    (0, $cxph1.goToNextPage)('/create-account');
                }
            }
            if (deepLinkPath.includes('foodid')) {
                const itemGuid = linkData.$itemGuid;
                const groupGuid = linkData.$groupGuid;
                goToMenuItem(itemGuid, groupGuid);
            }
        }
    }
    function checkInitialOffer() {
        const initialoffer = sessionStorage.getItem('initial');
        if (initialoffer != null) {
            sessionStorage.removeItem('initial');
            handleInitialOffer();
        }
    }
    function handleInitialOffer() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null) {
            if (currentUser.get('nuberconfirmed') == true) alert('You already redeemed this offer');
            else if (currentUser.get('anonymous') == true) {
                sessionStorage.setItem('initialoffer', 'true');
                (0, $cxph1.goToNextPage)('/create-account');
            } else {
                initialoffer = 'true';
                initialamount = locationObject.get('initialamount');
                const phone = currentUser.get('phonenumber');
                setUpPhoneVerify(phone);
            }
        } else {
            sessionStorage.setItem('initialoffer', 'true');
            (0, $cxph1.goToNextPage)('/create-account');
        }
    }
    checkInitialOffer();
    // MARK: - ORDER OPTIONS
    const homeDeliveryButton = document.getElementById('homeDeliveryButton');
    homeDeliveryButton.addEventListener('click', function() {
        sessionStorage.setItem('startDelivery', 'true');
        (0, $cxph1.goToNextPage)('/order');
    });
    const homePickUpButton = document.getElementById('homePickUpButton');
    homePickUpButton.addEventListener('click', function() {
        sessionStorage.setItem('startDelivery', 'false');
        (0, $cxph1.goToNextPage)('/order');
    });
    const progressModal = document.getElementById('progressModal');
    const signedInSection = document.getElementById('signedInSection');
    const homeBottomAccountButton = document.getElementById('homeBottomAccountButton');
    const homeBottomOrderButton = document.getElementById('homeBottomOrderButton');
    const homeTopRightPromoButton = document.getElementById('homeTopRightPromoButton');
    const leftPromoImage = document.getElementById('leftPromoImage');
    const rightTopPromoImage = document.getElementById('rightTopPromoImage');
    const rightBottomPromoImage = document.getElementById('rightBottomPromoImage');
    const homeLeftPromoButton = document.getElementById('homeLeftPromoButton');
    function setUpPage() {
        loadPromoOffers();
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null) {
            const anonymous = currentUser.get('anonymous');
            if (anonymous == false) {
                setUpUserSection();
                signedInSection.style.display = 'block';
                homeBottomAccountButton.innerText = 'REWARDS';
            }
        }
        if ((0, $i2HuG.isMobileDevice)() == false) setUpOrderDetails();
    }
    function setUpUserSection() {
        const currentUser = (0, $03cFT.default).User.current();
        const ribboncount = currentUser.get('ribboncount');
        var ribbonString = "WOLF PRINTS";
        if (ribboncount == 1) ribbonString = "WOLF PRINT";
        ribbonCountLabel.innerText = '' + ribboncount;
        ribbonsLabel.innerText = ribbonString;
        loadRewardItems();
        setUpPreviousOrders();
    }
    // MARK: - RIBBON VIEW
    const ribbonCountLabel = document.getElementById('ribbonCountLabel');
    const ribbonsLabel = document.getElementById('ribbonsLabel');
    const viewRewardsButton = document.getElementById('viewRewardsButton');
    const rewardItemsBlock = document.getElementById('rewardItemsBlock');
    var showRewards = false;
    viewRewardsButton.addEventListener('click', async ()=>{
        showRewards = !showRewards;
        if (showRewards == false) {
            viewRewardsButton.innerText = 'SHOW REWARDS';
            rewardItemsBlock.style.display = 'none';
        } else {
            viewRewardsButton.innerText = 'CLOSE REWARDS';
            rewardItemsBlock.style.display = 'flex';
        }
    });
    var rewards = [];
    async function loadRewardItems() {
        try {
            rewards = await (0, $03cFT.default).Cloud.run('loadToastRewards', {});
            setUpRewardItems();
        } catch (e) {
            alert(e.message);
        }
    }
    function setUpRewardItems() {
        const rewardsCell = document.querySelector('[rewards="cell"]');
        const rewardsParent = rewardsCell.parentNode;
        const rewardsCells = [
            ...document.querySelectorAll('[rewards="cell"]')
        ];
        for(let i = 0; i < rewards.length; i++){
            const newRewardsCell = i === 0 ? rewardsCells[0] : rewardsCells[0].cloneNode(true);
            const ribbonCountLabel = newRewardsCell.querySelector('[rewards="tibbonCountLabel"]');
            ribbonCountLabel.innerText = '' + rewards[i].get('ribbonCost');
            const itemPhoto = newRewardsCell.querySelector('[rewards="itemPhoto"]');
            itemPhoto.src = rewards[i].get('photo').url();
            const title = newRewardsCell.querySelector('[rewards="nameLabel"]');
            title.innerText = rewards[i].get('name').toUpperCase();
            rewardsParent.appendChild(newRewardsCell);
            newRewardsCell.addEventListener('click', ()=>{
                (0, $cxph1.goToNextPage)('/rewards');
            });
        }
    }
    // MARK: - QUICK ORDER
    const ordersModal = document.getElementById('ordersModal');
    const noOrdersDiv = document.getElementById('noOrdersDiv');
    const pastOrdersDiv = document.getElementById('pastOrdersDiv');
    const orderCountLabel = document.getElementById('orderCountLabel');
    const startOrderButton = document.getElementById('startOrderButton');
    const noQuickOrderDiv = document.getElementById('noQuickOrderDiv');
    const homeQuickOrderDiv = document.getElementById('homeQuickOrderDiv');
    const quickOrderDiv = document.getElementById('quickOrderDiv');
    const quickDateLabel = document.getElementById('quickDateLabel');
    const quickItemCount = document.getElementById('quickItemCount');
    const quickItemNamesLabel = document.getElementById('quickItemNamesLabel');
    const quickDiningOptionLabel = document.getElementById('quickDiningOptionLabel');
    const quickAddressLabel = document.getElementById('quickAddressLabel');
    const quickOrderButton = document.getElementById('quickOrderButton');
    const pastButtonDIv = document.getElementById('pastButtonDIv');
    const quickOpenIcon = document.getElementById('quickOpenIcon');
    const quickButtonDIv = document.getElementById('quickButtonDIv');
    const pastOpenIcon = document.getElementById('pastOpenIcon');
    const homePastOrdersDiv = document.getElementById('homePastOrdersDiv');
    const noPastOrderDiv = document.getElementById('noPastOrderDiv');
    const reorderPastOrderButton = document.getElementById('reorderPastOrderButton');
    const pastOrders = document.getElementById('pastOrders');
    const pastOrderCellDiv = document.getElementById('pastOrderCellDiv');
    var previousOrders = [];
    var quickOrder;
    var reorderOrder;
    async function setUpPreviousOrders() {
        previousOrders = await (0, $03cFT.default).Cloud.run('loadPreviousOrders', {});
        if (previousOrders.length == 0) {
            noOrdersDiv.style.display = 'block';
            pastOrdersDiv.style.display = 'none';
            noPastOrderDiv.style.display = 'block';
            pastOrders.style.display = 'none';
        } else {
            noOrdersDiv.style.display = 'none';
            noPastOrderDiv.style.display = 'none';
            pastOrdersDiv.style.display = 'flex';
            pastOrders.style.display = 'block';
            orderCountLabel.innerText = 'Orders ( ' + previousOrders.length + ' )';
            setPreviousOrdersTable();
            setPastCollectionCells();
            //setPastOrderTable();
            quickOrder = previousOrders.find((obj)=>obj.get('favorite') === true);
            setQuickOrder();
            reorderOrder = previousOrders[0];
            setPastOrder();
            setPastOrderCellColor();
        }
    }
    function setQuickOrder() {
        if (quickOrder != null) {
            noQuickOrderDiv.style.display = 'none';
            quickOrderDiv.style.display = 'flex';
            quickOrderButton.style.display = 'block';
            const orderObject = quickOrder.get('orderObject');
            const openedDate = new Date(orderObject.openedDate);
            const formattedDate = openedDate.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'short',
                day: 'numeric'
            });
            const options = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };
            const hourString = openedDate.toLocaleString('en-US', options);
            quickDateLabel.innerText = formattedDate.toUpperCase() + ' - ' + hourString;
            const selections = orderObject.checks[0].selections;
            var quantity = 0;
            var itemNames = [];
            for (const selection of selections){
                quantity += selection.quantity;
                itemNames.push(selection.displayName.toUpperCase());
            }
            if (quantity == 1) quickItemCount.innerText = quantity + ' ITEM';
            else quickItemCount.innerText = quantity + ' ITEMS';
            quickItemNamesLabel.innerText = itemNames.join(', ');
            const deliveryInfo = orderObject.deliveryInfo;
            if (deliveryInfo != null) {
                quickDiningOptionLabel.innerText = 'DELIVERY';
                const address = deliveryInfo.address1;
                const apt = deliveryInfo.address2;
                const city = deliveryInfo.city;
                const state = deliveryInfo.state;
                const zipCode = deliveryInfo.zipCode;
                var addressString = address + ' - ' + city + ', ' + state + ' ' + zipCode;
                if (apt != null && apt != '') addressString = address + ', ' + apt + ' - ' + city + ', ' + state + ' ' + zipCode;
                quickAddressLabel.innerText = addressString.toUpperCase();
            } else {
                quickDiningOptionLabel.innerText = 'PICK UP';
                const locationobject = quickOrder.get('locationobject');
                const address = locationobject.get('address');
                const city = locationobject.get('city');
                const state = locationobject.get('state');
                const zipcode = locationobject.get('zipcode');
                const addressString = address + ' - ' + city + ', ' + state + ' ' + zipcode;
                quickAddressLabel.innerText = addressString.toUpperCase();
            }
        } else {
            noQuickOrderDiv.style.display = 'flex';
            quickOrderDiv.style.display = 'none';
            quickOrderButton.style.display = 'none';
        }
    }
    function setPastOrder() {
        if (reorderOrder != null) {
            const order = reorderOrder;
            const dateLabel = document.querySelector('[pastorder="dateLabel"]');
            const orderObject = order.get('orderObject');
            const openedDate = new Date(orderObject.openedDate);
            const formattedDate = openedDate.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'short',
                day: 'numeric'
            });
            const options = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };
            const hourString = openedDate.toLocaleString('en-US', options);
            dateLabel.innerText = formattedDate.toUpperCase() + ' - ' + hourString;
            const selections = orderObject.checks[0].selections;
            var quantity = 0;
            var itemNames = [];
            for (const selection of selections){
                quantity += selection.quantity;
                itemNames.push(selection.displayName.toUpperCase());
            }
            const itemCountLabel = document.querySelector('[pastorder="itemCountLabel"]');
            if (quantity == 1) itemCountLabel.innerText = quantity + ' ITEM';
            else itemCountLabel.innerText = quantity + ' ITEMS';
            const itemNamesLabel = document.querySelector('[pastorder="itemNamesLabel"]');
            itemNamesLabel.innerText = itemNames.join(', ');
            const deliveryInfo = orderObject.deliveryInfo;
            const diningOptionLabel = document.querySelector('[pastorder="diningOptionLabel"]');
            const addressLabel = document.querySelector('[pastorder="addressLabel"]');
            if (deliveryInfo != null) {
                diningOptionLabel.innerText = 'DELIVERY';
                const address = deliveryInfo.address1;
                const apt = deliveryInfo.address2;
                const city = deliveryInfo.city;
                const state = deliveryInfo.state;
                const zipCode = deliveryInfo.zipCode;
                var addressString = address + ' - ' + city + ', ' + state + ' ' + zipCode;
                if (apt != null && apt != '') addressString = address + ', ' + apt + ' - ' + city + ', ' + state + ' ' + zipCode;
                addressLabel.innerText = addressString.toUpperCase();
            } else {
                diningOptionLabel.innerText = 'PICK UP';
                const locationobject = order.get('locationobject');
                const address = locationobject.get('address');
                const city = locationobject.get('city');
                const state = locationobject.get('state');
                const zipcode = locationobject.get('zipcode');
                const addressString = address + ' - ' + city + ', ' + state + ' ' + zipcode;
                addressLabel.innerText = addressString.toUpperCase();
            }
        }
    }
    pastOrderCellDiv.addEventListener('click', ()=>{
        if (reorderOrder != null) {
            sessionStorage.setItem('parseOrder', JSON.stringify(reorderOrder));
            (0, $cxph1.goToNextPage)('/order-tracker');
        }
    });
    var quickOpen = true;
    quickOpenIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/678712710757697729ac920c_up.png';
    quickButtonDIv.addEventListener('click', ()=>{
        quickOpen = !quickOpen;
        if (quickOpen == true) {
            homeQuickOrderDiv.style.display = 'flex';
            quickOpenIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/678712710757697729ac920c_up.png';
        } else {
            homeQuickOrderDiv.style.display = 'none';
            quickOpenIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/678712716bb44379bbc2af7b_down.png';
        }
    });
    var pastOpen = false;
    pastButtonDIv.addEventListener('click', ()=>{
        pastOpen = !pastOpen;
        if (pastOpen == true) {
            homePastOrdersDiv.style.display = 'block';
            pastOpenIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/678712710757697729ac920c_up.png';
        } else {
            homePastOrdersDiv.style.display = 'none';
            pastOpenIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/678712716bb44379bbc2af7b_down.png';
        }
    });
    quickOrderButton.addEventListener('click', async ()=>{
        if (quickOrder != null) {
            progressModal.style.display = 'flex';
            const success = await (0, $1Sl9O.orderQuickOrder)(quickOrder);
            progressModal.style.display = 'none';
            if (success) (0, $cxph1.goToNextPage)('/checkout');
        }
    });
    reorderPastOrderButton.addEventListener('click', async ()=>{
        if (reorderOrder != null) {
            progressModal.style.display = 'flex';
            const success = await (0, $1Sl9O.orderQuickOrder)(reorderOrder);
            progressModal.style.display = 'none';
            if (success) (0, $cxph1.goToNextPage)('/checkout');
        }
    });
    function setPreviousOrdersTable() {
        const ordersCell = document.querySelector('[order="cell"]');
        const ordersParent = ordersCell.parentNode;
        const ordersCells = [
            ...document.querySelectorAll('[order="cell"]')
        ];
        for(let i = 0; i < previousOrders.length; i++){
            const newOrdersCell = i === 0 ? ordersCells[0] : ordersCells[0].cloneNode(true);
            const order = previousOrders[i];
            const dateLabel = newOrdersCell.querySelector('[order="dateLabel"]');
            const orderObject = order.get('orderObject');
            const openedDate = new Date(orderObject.openedDate);
            const formattedDate = openedDate.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'short',
                day: 'numeric'
            });
            const options = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };
            const hourString = openedDate.toLocaleString('en-US', options);
            dateLabel.innerText = formattedDate.toUpperCase() + ' - ' + hourString;
            const selections = orderObject.checks[0].selections;
            var quantity = 0;
            var itemNames = [];
            for (const selection of selections){
                quantity += selection.quantity;
                itemNames.push(selection.displayName.toUpperCase());
            }
            const itemCountLabel = newOrdersCell.querySelector('[order="itemCountLabel"]');
            if (quantity == 1) itemCountLabel.innerText = quantity + ' ITEM';
            else itemCountLabel.innerText = quantity + ' ITEMS';
            const itemNamesLabel = newOrdersCell.querySelector('[order="itemNamesLabel"]');
            itemNamesLabel.innerText = itemNames.join(', ');
            const deliveryInfo = orderObject.deliveryInfo;
            const diningOptionLabel = newOrdersCell.querySelector('[order="diningOptionLabel"]');
            const addressLabel = newOrdersCell.querySelector('[order="addressLabel"]');
            if (deliveryInfo != null) {
                diningOptionLabel.innerText = 'DELIVERY';
                const address = deliveryInfo.address1;
                const apt = deliveryInfo.address2;
                const city = deliveryInfo.city;
                const state = deliveryInfo.state;
                const zipCode = deliveryInfo.zipCode;
                var addressString = address + ' - ' + city + ', ' + state + ' ' + zipCode;
                if (apt != null && apt != '') addressString = address + ', ' + apt + ' - ' + city + ', ' + state + ' ' + zipCode;
                addressLabel.innerText = addressString.toUpperCase();
            } else {
                diningOptionLabel.innerText = 'PICK UP';
                const locationobject = order.get('locationobject');
                const address = locationobject.get('address');
                const city = locationobject.get('city');
                const state = locationobject.get('state');
                const zipcode = locationobject.get('zipcode');
                const addressString = address + ' - ' + city + ', ' + state + ' ' + zipcode;
                addressLabel.innerText = addressString.toUpperCase();
            }
            const favorite = order.get('favorite');
            const favoriteDiv = newOrdersCell.querySelector('[order="favoriteDiv"]');
            if (favorite == true) favoriteDiv.style.display = 'flex';
            else favoriteDiv.style.display = 'none';
            newOrdersCell.addEventListener('click', async ()=>{
                progressModal.style.display = 'flex';
                await (0, $03cFT.default).Cloud.run('setQuickOrder', {
                    'orderid': order.id
                });
                removeOrderCells();
                await setUpPreviousOrders();
                ordersModal.style.display = 'none';
                progressModal.style.display = 'none';
            });
            ordersParent.appendChild(newOrdersCell);
        }
    }
    function setPastCollectionCells() {
        const ordersCell = document.querySelector('[orderdate="cell"]');
        const ordersParent = ordersCell.parentNode;
        const ordersCells = [
            ...document.querySelectorAll('[orderdate="cell"]')
        ];
        for(let i = 0; i < previousOrders.length; i++){
            const newOrdersCell = i === 0 ? ordersCells[0] : ordersCells[0].cloneNode(true);
            const order = previousOrders[i];
            const dateButton = newOrdersCell.querySelector('[orderdate="dateButton"]');
            const orderObject = order.get('orderObject');
            const openedDate = new Date(orderObject.openedDate);
            const formattedDate = openedDate.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
            });
            dateButton.innerText = formattedDate.toUpperCase();
            newOrdersCell.addEventListener('click', async ()=>{
                reorderOrder = order;
                setPastOrder();
                setPastOrderCellColor();
            });
            ordersParent.appendChild(newOrdersCell);
        }
    }
    function setPastOrderCellColor() {
        if (reorderOrder != null) {
            const cells = [
                ...document.querySelectorAll('[orderdate="cell"]')
            ];
            var index = 0;
            for (const cell of cells){
                const order = previousOrders[index];
                const dateButton = cell.querySelector('[orderdate="dateButton"]');
                if (order != null) {
                    if (reorderOrder.id == order.id) {
                        dateButton.style.backgroundColor = '#000000';
                        dateButton.style.color = 'white';
                    } else {
                        dateButton.style.backgroundColor = 'white';
                        dateButton.style.color = '#000000';
                    }
                }
                index += 1;
            }
        }
    }
    function removeOrderCells() {
        const cells = [
            ...document.querySelectorAll('[order="cell"]')
        ];
        var index = 0;
        for (const cell of cells){
            if (index != 0) cell.remove();
            index += 1;
        }
    }
    startOrderButton.addEventListener('click', ()=>{
        const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        if (deliveryBool != null) (0, $cxph1.goToNextPage)('/menu');
        else (0, $cxph1.goToNextPage)('/order');
    });
    const chooseQuickOrderButton = document.getElementById('chooseQuickOrderButton');
    chooseQuickOrderButton.addEventListener('click', async ()=>{
        ordersModal.style.display = 'flex';
    });
    // MARK: - ORDER DETAILS
    const homeStartOrderSection = document.getElementById("homeStartOrderSection");
    const homeOrderDetailsSection = document.getElementById("homeOrderDetailsSection");
    const homeOrderInfoLabel = document.getElementById("homeOrderInfoLabel");
    async function setUpOrderDetails() {
        const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
        const location = JSON.parse(localStorage.getItem('location'));
        if (deliveryBool != null) {
            homeOrderDetailsSection.style.display = 'block';
            homeStartOrderSection.style.display = 'none';
            await setHomeOrderDetailsCart();
            if (deliveryBool) {
                if (deliveryAddress != null) {
                    const address = deliveryAddress.addressLabel.toUpperCase();
                    const city = deliveryAddress.city.toUpperCase();
                    const stateCode = deliveryAddress.stateCode.toUpperCase();
                    const postalCode = deliveryAddress.postalCode.toUpperCase();
                    homeOrderInfoLabel.innerText = 'DELIVERY: \n' + address + '\n' + city + ', ' + stateCode + ' ' + postalCode;
                } else {
                    sessionStorage.setItem('deliveryBool', 'false');
                    if (location != null) {
                        const address = location.address.toUpperCase();
                        const city = location.city.toUpperCase();
                        const stateCode = location.state.toUpperCase();
                        const postalCode = location.zipcode.toUpperCase();
                        homeOrderInfoLabel.innerText = 'PICK UP:\n' + address + '\n' + city + ', ' + stateCode + ' ' + postalCode;
                    }
                }
            } else if (location != null) {
                const address = location.address.toUpperCase();
                const city = location.city.toUpperCase();
                const stateCode = location.state.toUpperCase();
                const postalCode = location.zipcode.toUpperCase();
                homeOrderInfoLabel.innerText = 'PICK UP:\n' + address + '\n' + city + ', ' + stateCode + ' ' + postalCode;
            }
        }
    }
    async function setHomeOrderDetailsCart() {
        const homeCartDiv = document.getElementById("homeCartDiv");
        const homeCartCountLabel = document.getElementById("homeCartCountLabel");
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null && (0, $i2HuG.isMobileDevice)() == false) {
            await currentUser.fetch();
            const orderCheck = currentUser.get('orderCheck');
            if (orderCheck != null) {
                const checks = orderCheck.checks;
                if (checks != null) {
                    const check = checks[0];
                    const selections = check.selections;
                    if (selections.length == 0) homeCartDiv.style.display = 'none';
                    else {
                        homeCartDiv.style.display = 'flex';
                        var quantity = 0;
                        for (const selection of selections)quantity += selection.quantity;
                        homeCartCountLabel.innerText = '( ' + quantity + ' )';
                    }
                }
            }
        } else homeCartDiv.style.display = 'none';
    }
    setUpPage();
    // MARK: - BUTTONS
    var promoOffer;
    async function loadPromoOffers() {
        try {
            const promoOffers = await (0, $03cFT.default).Cloud.run('loadPromoOffers', {});
            if (promoOffers.length > 0) {
                const randomIndex = getRandomIntInclusive(0, promoOffers.length - 1);
                promoOffer = promoOffers[randomIndex];
                setPromoOffer(promoOffer);
            }
        } catch (e) {
            alert(e.message);
        }
    }
    function setPromoOffer(promoOffer) {
        const imageUrl = promoOffer.get('image').url();
        rightTopPromoImage.src = imageUrl;
    }
    function getRandomIntInclusive(min, max) {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
    }
    homeTopRightPromoButton.addEventListener('click', function() {
        //const itemGuid = '0842f225-8292-4421-9ccc-910fc2357f1d';
        //const groupGuid = 'd63ab0f1-74f8-45a9-bd47-963b163b5506';
        if (promoOffer != null) {
            const identifier = promoOffer.get('identifier');
            if (identifier == 'menuitem') {
                const itemGuid = promoOffer.get('itemGuid');
                const groupGuid = promoOffer.get('groupGuid');
                goToMenuItem(itemGuid, groupGuid);
            }
            if (identifier == "menugroup") {
                const groupGuid = promoOffer.get('groupGuid');
                goToMenuGroup(groupGuid);
            }
        }
    });
    leftPromoImage.addEventListener('click', function() {
        const groupGuid = 'd4377348-5685-496e-8baa-9e57aa30ee53';
        goToMenuGroup(groupGuid);
    });
    homeLeftPromoButton.addEventListener('click', function(e) {
        e.stopPropagation(); // prevents the image click from also firing
        const groupGuid = 'd4377348-5685-496e-8baa-9e57aa30ee53';
        goToMenuGroup(groupGuid);
    });
    rightTopPromoImage.addEventListener('click', function() {
        if (promoOffer != null) {
            const identifier = promoOffer.get('identifier');
            if (identifier == 'menuitem') {
                const itemGuid = promoOffer.get('itemGuid');
                const groupGuid = promoOffer.get('groupGuid');
                goToMenuItem(itemGuid, groupGuid);
            }
            if (identifier == "menugroup") {
                const groupGuid = promoOffer.get('groupGuid');
                goToMenuGroup(groupGuid);
            }
        }
    });
    rightBottomPromoImage.addEventListener('click', function() {
        (0, $cxph1.goToNextPage)('/order');
    });
    async function goToMenuItem(itemGuid, groupGuid) {
        progressModal.style.display = 'flex';
        const menuItem = await (0, $3w2h1.getToastItem)(groupGuid, itemGuid);
        const menuCategory = await (0, $3w2h1.getToastGroup)(groupGuid);
        progressModal.style.display = 'none';
        sessionStorage.setItem('category', JSON.stringify(menuCategory));
        sessionStorage.setItem('menuItem', JSON.stringify(menuItem));
        (0, $cxph1.goToNextPage)('/item');
    }
    async function goToMenuGroup(groupGuid) {
        progressModal.style.display = 'flex';
        const toastMenus = sessionStorage.getItem('toastMenus');
        if (!toastMenus) await loadToastMenus();
        const menuCategory = await (0, $3w2h1.getToastGroup)(groupGuid);
        progressModal.style.display = 'none';
        sessionStorage.setItem('category', JSON.stringify(menuCategory));
        (0, $cxph1.goToNextPage)('/menu');
    }
    homeBottomAccountButton.addEventListener('click', function() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null) {
            const anonymous = currentUser.get('anonymous');
            if (anonymous == false) (0, $cxph1.goToNextPage)('/rewards');
            else (0, $cxph1.goToNextPage)('/create-account');
        } else (0, $cxph1.goToNextPage)('/create-account');
    });
    homeBottomOrderButton.addEventListener('click', function() {
        const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        if (deliveryBool != null) (0, $cxph1.goToNextPage)('/menu');
        else (0, $cxph1.goToNextPage)('/order');
    });
    // MARK: - VERIFY PHONE
    var phoneNumber;
    var codeSent = false;
    $("#verifyForm").submit(()=>{
        return false;
    });
    function setUpPhoneVerify(phone) {
        phoneNumber = phone;
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phone);
        if (initialoffer != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER - VALID ONE TIME PER CUSTOMER';
        verifyModal.style.display = 'flex';
    }
    resendCodeButton.addEventListener('click', async ()=>{
        resetView();
    });
    verifySmsButton.addEventListener('click', async ()=>{
        if (codeSent === false) {
            phoneNumber = verifyPhoneTextField.value.replace(/\D/g, '');
            var error = '';
            if (phoneNumber.length != 10) error = 'Please enter full 10 digits';
            if (error != '') alert(error);
            else checkPhoneNumber(phoneNumber);
        } else {
            // verify with code
            const code = verifyPhoneTextField.value;
            var error = '';
            if (code.length != 6) error = 'Please enter 6 digit code sent in SMS';
            if (error != '') alert(error);
            else verifyPhoneNumber(phoneNumber, code);
        }
    });
    closeVerifyButton.addEventListener('click', async ()=>{
        verifyModal.style.display = 'none';
    });
    async function verifyPhoneNumber(phone, code) {
        progressModal.style.display = 'flex';
        try {
            const status = await (0, $03cFT.default).Cloud.run('verifyTextCodeWeb', {
                'phone': phone,
                'code': code
            });
            if (status === 'approved') {
                const request = {
                    'phone': phoneNumber,
                    'initialamount': initialamount,
                    'locationid': (0, $kcvY9.default)
                };
                await (0, $03cFT.default).Cloud.run('updateUserVerificationAndRefferal', request);
                const currentUser = (0, $03cFT.default).User.current();
                if (currentUser != null) await currentUser.fetch();
                (0, $cxph1.goToNextPage)('/profile');
            } else alert('Code failed please try again');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function checkPhoneNumber(phone) {
        progressModal.style.display = 'flex';
        try {
            const available = await (0, $03cFT.default).Cloud.run('checkPhoneNumber', {
                "phone": phone
            });
            if (available == true) await sendCode(phone);
            else alert('Offer already redeemed by this phone number');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function sendCode(phone) {
        const status = await (0, $03cFT.default).Cloud.run('sendTextVerificationWeb', {
            "phone": phone
        });
        if (status === "pending") {
            verifyPhoneTextField.value = '';
            verifyPhoneTextField.placeholder = 'Enter Code';
            verifyTopLabel.innerText = 'ENTER 6 DIGIT CODE';
            resendCodeButton.style.display = 'block';
            verifySmsButon.value = 'VERIFY';
            verifyPhoneTextField.focus();
            codeSent = true;
        } else alert('Code failed to send');
    }
    async function resetView() {
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phoneNumber);
        verifyTopLabel.innerText = 'TO RECEIVE THIS OFFER YOU MUST VERIY PHONE NUMBER VIA SMS';
        resendCodeButton.style.display = 'none';
        verifySmsButton.value = 'SEND SMS CODE';
        codeSent = false;
        if (initialoffer != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        if (referralid != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
    }
});


//# sourceMappingURL=Lupo.0ac59434.js.map
